import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  HostListener,
  AfterViewChecked,
  OnDestroy,
} from '@angular/core';
import { NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { NgForm } from '@angular/forms';
import { UserService } from './../../../shared/services/user.service';
import { CommonService } from '../../../shared/services/common.service';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { Message } from 'src/app/message';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
} from '@angular/forms';
import { LoadingService } from '../../../shared/services/loading.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import * as countrycodes from 'src/app/shared/JSON/coutrycode.json';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';
import { PlansComponent } from '../../plans/plans.component';
import { PlansService } from 'src/app/shared/services/plans.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {
  LocationService,
  LocationCoords,
} from '../../../shared/services/location.service'; // ← ADD import

declare var FB: any;
declare var webengage: any;

const PB_SIGNUP_FLOW_START_TS = 'pb_signup_flow_start_ts';
const PB_SIGNUP_OTP_FAILURE_COUNT = 'pb_signup_otp_failure_count';

declare function androidRegionCheck(): any;
declare var fbq: Function;
// declare function npawPlugin(): any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  coords: LocationCoords | null = null; // ← ADD
  loading: boolean = false;
  ageOptions: number[] = [];
  mobileNumber: string;
  userAccountMenuBeforeLogin: boolean = false;
  verifyToken: FormGroup;
  verifyTokenEmail: FormGroup;
  successFlag: boolean = false;
  errorMessage: string = '';
  errorFlag: boolean = false;
  loginStatus: boolean = false;
  errorStatus: boolean = false;
  statusMessage: any;
  backendErrorStatus: boolean = true;
  userMobileLogin: FormGroup;
  formGroupGDPI: FormGroup;
  userEmailLogin: FormGroup;
  userEmailPasswordLogin: FormGroup;
  userForgotPassword: FormGroup;
  userProfile: FormGroup;
  registerForm: FormGroup;
  timer: any = {};
  getUserid: FormGroup;
  new_userid: number;
  forgotPassMobileNumber: string = '';
  forgotPassEmailId: string = '';
  browser: string = 'web';
  user_det: any = {
    user_name: '',
  };
  loginTypes: 'mobile' | 'email' = 'email';
  
  userAccountMenu: any = false;
  countryCodeStatus: boolean = false;
  header_tabs: any;
  language: any;
  mobileMenu: boolean = false
  profileMenu: boolean = false;
  mobileMenuOpen: boolean = true;
  loginPop: string;
  continueWatchLength: any;
  user: any = {};
  updateUser: FormGroup;
  backendMessageStatus: boolean = false;
  activeMenuString: string;
  loginType: string = '';
  maxDate: Date;
  session: string = '';
  region: string = '';
  floatLabelControl = new FormControl('always');
  countryCodes: any = (countrycodes as any).default;
  public searchFilter: any = '';
  defaultCountrycode: any = [];
  // callingCode:any = '';
  callingCode: string = '+91';
  minPhnLimit: number;
  maxPhnLimit: number;
  closeSwitchNetworkPopup: boolean = false;
  retryToast: boolean = false;
  otpMobileValue: any = '0000000000';
  showUpdateProfile: boolean = false;
  showChangeNumber: boolean = false;
  showChangeName: boolean = false;
  showChangeEmail: boolean = false;
  showProfileUpdateOtp: boolean = false;
  showLoginOTP: boolean = false;
  showLoginEmailOTP: boolean = false;
  keepOtpCountdown: boolean = false;
  private readonly idleTimeoutMs = 60 * 60 * 1000;
  private lastActivityAt = Date.now();
  private idleCheckTimer: any;
  private idleLogoutFired = false;
  userProfileDetails: any = {};
  ad_slot1: any;
  isSessionExpired: boolean = false;
  isGDPIApproved: boolean = true;
  isDesktop: boolean = false;
  isMobile: boolean = false;
  isTab: boolean = false;
  isSTab: boolean = false;
  showSursangramPop: boolean = false;
  showDiffRegionPop: boolean = false;
  // forgot_userid_mobile = new FormControl('')
  forgot_pasword_mobile = new FormControl('');
  forgot_pasword_email = new FormControl('');
  forgotPasswordOtp: any = '';
  loginDetails: any;
  gdprText: string = '';
  termsAndConditionUrl: string = '';
  isParentalControlEnabled: boolean = false;
  isRegisterPopupVisible = false;
  termsAccepted: boolean = false;
  hasAttemptedSubmit: boolean = false;
  disableActivate: boolean = true;
  activePlans: string;
  accessPack: string;
  showSubscribeButton: boolean = false;
  supportedRegion: any = [];
  gdprFlag: boolean = false;
  gdprforregion: boolean = false;
  showGDPRPopup: boolean = false;
  signed_emailid: string;
  isGdprPopupVisible: boolean = true;
  deviceType: any = '';
  changePasswordForm!: FormGroup;
  submitted = false;
  showPassword = false;
  showConfirmPassword = false;
  forgotPinSecretKey!: string;

  // npawContentId: string;
  // npawSource:string = 'organic';

  // userProfileForm
  @ViewChild('verifyTokenForm', { static: false })
  public verifyTokenForm: NgForm;
  @ViewChild('verifyTokenEmailForm', { static: false })
  public verifyTokenEmailForm: NgForm;
  @ViewChild('mobileLoginForm', { static: false })
  public mobileLoginForm: NgForm;
  @ViewChild('emailLoginForm', { static: false }) public emailLoginForm: NgForm;
  @ViewChild('userProfileForm', { static: false })
  public userProfileForm: NgForm;
  upcomingMenuOpen: boolean = false;
  UpcomingData: any;

  constructor(
    private broadcastService: BroadcastService,
    private userService: UserService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private snackbar: MatSnackBar,
    public globalService: GlobalService,
    private location: Location,
    private analytics: AngularFireAnalytics,
    private plansService: PlansService,
    private activatedRoute: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    private locationService: LocationService,
  ) {
    this.userMobileLogin = this.fb.group({
      floatLabel: this.floatLabelControl,
    });

    this.userEmailLogin = this.fb.group({
      floatLabel: this.floatLabelControl,
    });

    this.userProfile = this.fb.group({
      floatLabel: this.floatLabelControl,
    });
    if (
      this.router['browserUrlTree']?.queryParams &&
      this.router['browserUrlTree']?.queryParams?.browser
    ) {
      this.browser = this.router['browserUrlTree']?.queryParams?.browser;
    }
    if (window.innerWidth < 1200) {
      this.browser = 'mweb';
    } else {
      this.browser = 'web';
    }

    if (this.deviceService.isMobile()) {
      this.deviceType = 'mweb';
    } else if (this.deviceService.isTablet()) {
      this.deviceType = 'Tablet';
    } else {
      this.deviceType = 'browser';
    }

    // this.router.events.subscribe((event: NavigationEvent) => {
    $('.modal').modal('hide');
    $('body').removeClass('menu-open');
    window.scrollTo(0, 0);
    if (
      this.router['browserUrlTree'] &&
      this.router['browserUrlTree']?.queryParams
    ) {
      if (
        this.router['browserUrlTree']?.queryParams?.browser == 'mobile' ||
        this.router['browserUrlTree']?.queryParams?.browser == 'android' ||
        this.router['browserUrlTree']?.queryParams?.browser == 'ios'
      ) {
        this.browser = this.router['browserUrlTree']?.queryParams?.browser;
        this.region = this.router['browserUrlTree']?.queryParams?.region;
      }
      if (
        this.router['browserUrlTree']?.queryParams?.utm_medium == 'appStores' ||
        this.router['browserUrlTree']?.queryParams?.share_url == 'true'
      ) {
        this.analytics.logEvent('utm_link', {
          source: window.location.href.slice(-100),
          platform: this.browser,
        });

        // this.userService.analytics(data).subscribe(
        //   (resp) => {
        //     //console.log(resp);
        //   },
        //   (error: any) => {
        //     if (error.server_error_code === '1016') {
        //       this.broadcastService.dispatch(
        //         new Message('sessionExpired', null)
        //       );
        //     }
        //   }
        // );
      }
      if (
        this.router['browserUrlTree']?.queryParams?.utm_medium == 'appStores' ||
        this.router['browserUrlTree']?.queryParams?.source == 'zingplay'
      ) {
        if (
          this.deviceService.getDeviceInfo().os == 'iOS' ||
          this.deviceService.getDeviceInfo().os == 'Mac'
        ) {
          setTimeout(() => {
            window.location.href =
              'https://apps.apple.com/in/app/dangal-play/id1635779590';
          }, 1500);
        } else {
          setTimeout(() => {
            window.location.href =
              'https://play.google.com/store/apps/details?id=com.tarangplus.tv&pli=1';
          }, 1500);
        }
      }
    }
    let menuString: any;
    // if (event instanceof NavigationEnd) { /* Your code goes here on every router change */
    // if(event.url.split('/').length <= 2){
    menuString =
      this.location.path() == '' ? 'home' : this.location.path().split('/')[1];
    if (this.location.path().split('/')[1] == 'users') {
      menuString = this.location.path().split('/')[2];
    } else if (this.location.path().split('/')[1] == 'live-tv') {
      menuString = 'o-live';
    } else if (this.location.path().split('/')[1] == 'shorts') {
      menuString = 'shorts-list';
    } else if (this.location.path().split('/')[1] == 'home') {
      menuString = 'home';
      this.router.navigate(['/']);
    } else if (this.location.path().split('/')[1] == 'signin') {
      let l = this;
      if (!window.localStorage.getItem('otv_user_id')) {
        $(document).ready(function () {
          l.loginScreen();
        });
      } else {
        this.router.navigate(['/']);
      }
    }
    // this.globalService.setGlobalTabName(menuString)
    if (window.localStorage) {
      window.localStorage.setItem('globalTabName', menuString);
    }
    // //console.log("this.activeMenuString",menuString);
    // }
    if (window.localStorage) {
      this.activeMenuString = window.localStorage.getItem('globalTabName');
    }

    if (window.localStorage) {
      this.gdprText = window.localStorage.getItem('gdprText');
    }

    this.mobileMenu = false;
    this.profileMenu = false;
    this.mobileMenuOpen = true;
    // }
    // });

    // this.broadcastService.on(new Message('login', null)).subscribe(event => this.loginPopup());

    this.broadcastService
      .on(new Message('switchnetworkpopup', null))
      .subscribe((event) => this.showSwitchNetworkPopup());

    this.broadcastService
      .on(new Message('getContiueWatching', null))
      .subscribe((event) => this.getContinueWatching());

    this.broadcastService
      .on(new Message('sessionExpired', null))
      .subscribe((event) => this.sessionExpired());

    // this.broadcastService.on(new Message('enableSursangramPopup', null)).subscribe(event => this.showSursangram());

    this.broadcastService
      .on(new Message('logout', null))
      .subscribe((event) => this.refreshPage());

    this.broadcastService
      .on(new Message('showRegionCheck', null))
      .subscribe((event) => this.fireRegionCheck());

    this.broadcastService
      .on(new Message('showDiffRegionPop', null))
      .subscribe((event) => this.popupForDiffRegion());

    this.broadcastService
      .on(new Message('openLogin', null))
      .subscribe((event) => this.loginBasedonRegion());
  }

  getLocation(): void {
    this.loading = true;
    this.locationService.getCurrentLocation().subscribe({
      next: (coords) => {
        this.coords = coords;
        this.loading = false;
        this.plansService
          .locationTrack(coords.latitude, coords.longitude, this.session)
          .subscribe({
            next: (res) => {
              console.log('✓ Location tracked successfully', res);
              this.loading = false;
            },
            error: (apiErr) => {
              console.error('✗ API error:', apiErr);
              this.loading = false;
            },
          });
      },
      error: (err) => {
        this.errorMessage = err;
        this.loading = false;
        const regionDetails = window.localStorage.getItem('regionDetails');

        if (regionDetails) {
          const parsedData = JSON.parse(regionDetails);

          const latitude = parsedData.region.latitude;
          const longitude = parsedData.region.longitude;
          this.plansService
            .locationTrack(latitude, longitude, this.session)
            .subscribe({
              next: (res) => {
                console.log('✓ Location tracked successfully', res);
                this.loading = false;
              },
              error: (apiErr) => {
                console.error('✗ API error:', apiErr);
                this.loading = false;
              },
            });
        }
        // alert(`Error getting location: ${err}`);
      },
    });
  }

  private useFallbackLocation(): void {
    console.log('Using fallback location from localStorage');
    const regionDetails = localStorage.getItem('regionDetails');
    if (regionDetails) {
      try {
        const parsedData = JSON.parse(regionDetails);
        const latitude = parsedData?.region?.latitude;
        const longitude = parsedData?.region?.longitude;
        console.log('Fallback location:', latitude, longitude);
        this.coords = { latitude, longitude };
      } catch (parseError) {
        console.error('Invalid regionDetails JSON:', parseError);
      }
    }
    this.loading = false;
  }

  shouldShowPopup(): boolean {
    const currentUrl = this.router.url;
    const isRegionSupported = this.supportedRegion.includes(this.region);
    const isGdprPopup = localStorage.getItem('gdpr_flag') === 'true';
    // //console.log('isRegionSupported:', isRegionSupported);
    // //console.log('gdprFlag:', isGdprPopup);
    return (
      this.session &&
      this.region !== 'IN' &&
      isRegionSupported &&
      isGdprPopup &&
      this.browser !== 'ios' &&
      this.browser !== 'android' &&
      currentUrl !== '/terms_and_conditions'
    );
  }
  @HostListener('document:visibilitychange', ['$event'])
  visibilitychange() {
    let t = this;
    this.checkHiddenDocument(t);
  }

  checkHiddenDocument(t) {
    if (this.browser != 'android') {
      if (document.hidden) {
        //console.log("hidden: true");
      } else {
        //console.log("hidden: false");
        if (window.localStorage.getItem('otv_user_id')) {
          t.userService.autoRegion(this.region).subscribe(
            (resp) => {
              // //console.log(resp)
              let oldRegion = window.localStorage.getItem('region');
              t.region = resp['region'].country_code2;
              window.localStorage.setItem(
                'portal_code',
                resp['region'].postal_code,
              );
              // window.location.reload();
              window.localStorage
                ? window.localStorage.setItem('region', this.region)
                : '';
              if (oldRegion && oldRegion != t.region) {
                if (t.browser == 'web') {
                  t.fireRegionCheck();
                } else {
                  androidRegionCheck();
                }
              }
              this.callingCode = resp['region'].calling_code.startsWith('00')
                ? '+' + resp['region'].calling_code.split('00')[1]
                : resp['region'].calling_code;
              this.defaultCountrycode = this.countryCodes.filter(
                (item) => item.code === this.region,
              )[0];
            },
            (error: any) => {
              //invalid session
              if (error.server_error_code === '1016') {
                this.sessionExpired();
              }
              // //console.log("autoDetact failed");
            },
          );
        }
        if (document.location.pathname == '/') {
          t.appConfigApi(false);
        }
      }
    }
  }

  showSwitchNetworkPopup() {
    this.closeSwitchNetworkPopup = true;
  }

  loginScreen() {
    // //console.log('showloginScreen');
    this.showPop('signin_pop', '');
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  ngOnInit() {
    this.changePasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6)]],
        confirm_password: ['', Validators.required],
      },
      {
        validators: this.passwordMatchValidator,
      },
    );

    this.route.queryParams.subscribe((params) => {
      this.forgotPinSecretKey = params['forgot_pin_secret_key'];
      console.log('forgot_pin_secret_key:', this.forgotPinSecretKey);
    });

    this.userService.autoRegion(this.region).subscribe((resp) => {
      this.region = resp['region'].country_code2;
      window.localStorage.setItem('IPzip', JSON.stringify(resp.region));
      window.localStorage.setItem('region', this.region);
    });

    this.userEmailPasswordLogin = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });

    this.userForgotPassword = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

   /* (window as any).fbAsyncInit = function () {
      FB.init({
        appId: '1304591476382466', // your App ID
        cookie: true,
        xfbml: false,
        version: 'v19.0',
      });

      FB.AppEvents.logPageView();
    };
*/
    // const route = this.getDeepestChild(this.activatedRoute);
    // const skipByRoute: boolean = route.snapshot.data?.['skipHeaderApis'] === true;
    // alert(skipByRoute)

    if (this.browser !== 'android') {
      this.regionAutoDetect();
    }
    this.setLoginStatus();
    this.initializeForms();

    if (window.innerWidth > 1199) {
      this.isDesktop = true;
    } else if (window.innerWidth > 767 && window.innerWidth < 1200) {
      this.isTab = true;
    } else if (window.innerWidth > 480 && window.innerWidth < 768) {
      this.isSTab = true;
    } else if (window.innerWidth < 481) {
      this.isMobile = true;
    }

    // this.autoLogin('');

    if (window.localStorage != null) {
      this.session = window.localStorage.getItem('otv_user_id');
      this.browser = window.localStorage.getItem('browser');
    }

    // this.showPop('sursangram_pop', '');
    //let session = "39dc7e55ec4e1f32698ef9ca05505f61";
    // if(window.localStorage.getItem("otv_user_id")){
    //     session = window.localStorage.getItem("otv_user_id");
    // }
    this.userDetails();
    this.ageOptions = Array.from({ length: 83 }, (_, i) => i + 18);

    const storedState = localStorage.getItem('parentalControl');
    if (storedState !== null) {
      this.isParentalControlEnabled = storedState === 'true';
    }
    // parental lock on refresh getting back to home
    const redirectToHome = localStorage.getItem('redirectToHome');
    if (redirectToHome === 'true') {
      localStorage.removeItem('redirectToHome');
      this.router.navigate(['/']); // Navigate to the home page
    }
    if (!this.session) {
      this.broadcastService.dispatch(new Message('login', null));
    } else {
      this.verifyToken = this.fb.group({
        in1: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('/^[a-zA-Z0-9]/g'),
        ]),
        in2: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ]),
        in3: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ]),
        in4: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ]),
        in5: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ]),
        in6: new FormControl('', [
          Validators.required,
          Validators.maxLength(1),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ]),
      });
    }
  }

  passwordMatchValidator(control: AbstractControl) {
    const password = control.get('password')?.value;
    const confirmPassword = control.get('confirm_password')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      control.get('confirm_password')?.setErrors({ mismatch: true });
    } else {
      const errors = control.get('confirm_password')?.errors;
      if (errors) {
        delete errors['mismatch'];
        if (!Object.keys(errors).length) {
          control.get('confirm_password')?.setErrors(null);
        }
      }
    }
    return null;
  }

  onSubmit() {
    this.submitted = true;

    if (this.changePasswordForm.invalid) {
      return;
    }
    const reset_params = {
      user: {
        password: this.changePasswordForm.value.password,
        confirm_password: this.changePasswordForm.value.confirm_password,
        region: this.region,
        key: window.localStorage.getItem('forgot_otp'),
        type: 'msisdn',
        email_id: localStorage.getItem('forgot_password_email'),
      },
    };

    console.log(reset_params);

    this.plansService.changePassword(reset_params, this.region).subscribe({
      next: (res) => {
        console.log('Success:', res);
        this.showLogin();
      },
      error: (err) => {
        console.error('Change password error:', err);
        const msg = err?.error?.error?.message || 'Something went wrong';
        alert('Error changing password: ' + msg);
      },
    });
  }

  setActiveMenu(menu: string) {
    this.activeMenuString = menu;
  }

  isActiveHeaderTab(m: any): boolean {
    if (!m) {
      return false;
    }
    if (m['home_link'] === this.activeMenuString) {
      return true;
    }
    const shortsSlugs = ['shorts', 'shorts-list'];
    return (
      shortsSlugs.indexOf(m['home_link']) !== -1 &&
      shortsSlugs.indexOf(this.activeMenuString) !== -1
    );
  }
  autoLogin(session_id) {}
  setLoginStatus() {
    this.loginStatus = !!window.localStorage.getItem('otv_user_id');
  }

  showSursangram() {
    if (window.location.pathname != '/sursangram') {
      this.showSursangramPop = true;
    }
  }

  fireRegionCheck() {
    // this.showDiffRegionPop = false;
    $('.modal').modal('hide');
    if (window.localStorage.getItem('otv_user_id')) {
      this.commonService.removeOtvUserLocalStorage();
    }
    this.session = '';
    this.loginStatus = false;
    // this.router.navigate(['/'], {state: {flag: 'diffRegionPop'}});
    if (this.location.path() == '') {
      this.showDiffRegionPop = true;
    } else {
      this.router.navigate(['/'], { state: { flag: 'diffRegionPop' } });
    }
  }

  popupForDiffRegion() {
    $('#region_change_pop').modal('show');
    // this.isSessionExpired = true;
    this.showDiffRegionPop = true;
  }

  fixCode(formName, formControl) {
    // //console.log(formName.get(formControl).value)
    if (
      formName.controls.sign_in_userid ||
      formName.get(formControl).value.length == 0 ||
      formName.get(formControl).value.length < 3
    ) {
      formName.get(formControl).setValue(this.callingCode);
    }
  }

  showErrorSnackbar(formgrp, formControlName) {
    // //console.log(formgrp.controls[formControlName].errors);
    if (formgrp.controls[formControlName].errors) {
      if (formgrp.controls[formControlName].errors.required) {
        // //console.log(formgrp.controls[formControlName].errors);

        if (formControlName === 'user_register_mobile') {
          this.snackbar.open(`Enter a valid 9mobile number`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        // if (formControlName === "user_register_name") {
        //   this.snackbar.open(`Enter a valid user name`, '', {
        //     duration: 3000,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center',
        //     panelClass: ['red-snackbar'],

        //   })
        // }
        // if (formControlName === "user_register_email") {
        //   this.snackbar.open(`Enter a valid email`, '', {
        //     duration: 2500,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center',
        //     panelClass: ['red-snackbar'],

        //   })
        // }
        if (formControlName === 'user_register_password') {
          this.snackbar.open(`Password cannot be blank`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (formControlName === 'sign_in_userid') {
          this.snackbar.open(`Enter a valid User ID`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (formControlName === 'sign_in_password') {
          this.snackbar.open(`Password cannot be blank`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'frgt_pwd_mobile_no') {
          this.snackbar.open(`User Id cannot be empty`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'reset_password') {
          this.snackbar.open(`Password cannot be blank`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'reset_confirm_password') {
          this.snackbar.open(`Password cannot be blank`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'frgt_userid_mobile_no') {
          this.snackbar.open(`Mobile Number cannot be empty`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        // if (formControlName === "userid_inputfeild") {
        //   this.snackbar.open(`Enter a valid User ID`, '', {
        //     duration: 3000,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center',
        //     panelClass: ['red-snackbar'],

        //   })
        // }
      }

      if (formgrp.controls[formControlName].errors.minlength) {
        if (formControlName === 'user_register_mobile') {
          this.snackbar.open(`Enter a valid 9mobile number`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (formControlName === 'user_register_password') {
          // this.snackbar.open(`Minimum length of 8 characters is mandatory`, '', {
          //   duration: 2500,
          //   verticalPosition: 'top',
          //   horizontalPosition: 'center',
          //   panelClass: ['red-snackbar'],
          // })
        }

        if (
          formControlName === 'user_register_confirm_password' ||
          formControlName === 'reset_confirm_password'
        ) {
          this.snackbar.open(`Password Minimum length is 8 characters`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (formControlName === 'sign_in_userid') {
          this.snackbar.open(`User id Minimum length is 8 characters`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'sign_in_password') {
          this.snackbar.open(`Password Minimum length is 8 characters`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'frgt_pwd_mobile_no') {
          this.snackbar.open(`Invalid User Id`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'reset_password') {
          this.snackbar.open(`Password Minimum length is 8 characters`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (formControlName === 'frgt_userid_mobile_no') {
          this.snackbar.open(`Enter a valid 9mobile number`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
      }

      if (formgrp.controls[formControlName].errors.maxlength) {
        if (formControlName === 'user_register_mobile') {
          this.snackbar.open(`Enter a valid 9mobile number`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'sign_in_userid') {
          this.snackbar.open(`User id Maximum length is 8 characters`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'frgt_pwd_mobile_no') {
          this.snackbar.open(`Invalid User Id`, '', {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
        if (formControlName === 'reset_password') {
          // this.snackbar.open(`Minimum length of 8 characters is mandatory`, '', {
          //   duration: 2500,
          //   verticalPosition: 'top',
          //   horizontalPosition: 'center',
          //   panelClass: ['red-snackbar'],
          // })
        }
        if (formControlName === 'frgt_userid_mobile_no') {
          this.snackbar.open(
            `Mobile number should not be more than 10 digits`,
            '',
            {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['red-snackbar'],
            },
          );
        }
      }

      if (
        formgrp.controls[formControlName].errors.email ||
        formgrp.controls[formControlName].errors.pattern
      ) {
        if (
          formControlName === 'user_register_email' ||
          formControlName === 'user_profile_email'
        ) {
          this.snackbar.open(`Email Id is invalid`, '', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }

        if (
          formControlName === 'user_register_password' ||
          formControlName === 'reset_password'
        ) {
          if (formgrp.controls[formControlName].errors.minLength) {
            // this.showErrorMsgSnackbar('Minimum length of 8 characters is mandatory')
          }
        }
      }

      if (formgrp.controls[formControlName].errors.mustMatch) {
        if (formControlName === 'user_register_confirm_password') {
          {
            this.snackbar.open(`Password should be same`, '', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['red-snackbar'],
            });
          }
        }
        if (formControlName === 'reset_confirm_password') {
          this.snackbar.open(`Password should be same`, '', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['red-snackbar'],
          });
        }
      }
    }
  }

  showSuccessMsgSnackbar(sucess_msg) {
    this.snackbar.open(sucess_msg, 'X', {
      verticalPosition: 'top',
      horizontalPosition: 'center',
      // panelClass: ['info-snackbar'],
      // panelClass: ['alert-snackbar'],
      panelClass: ['success-snackbar'],
      duration: 3000,
    });
  }

  showErrorMsgSnackbar(err_msg) {
    this.snackbar.open(err_msg, 'X', {
      verticalPosition: 'top',
      horizontalPosition: 'center',
      // panelClass: ['red-snackbar'],
      // panelClass: ['info-snackbar'],
      panelClass: ['alert-snackbar'],
      // panelClass: ['success-snackbar'],
      duration: 3000,
    });
  }

  startTimer(stop) {
    if (this.timer.oldIntervalId) {
      clearInterval(this.timer.oldIntervalId);
      this.timer.oldIntervalId = null;
    }
    this.timer.sec = stop ? 0 : 120;

    if (this.timer.sec == 0) {
      return;
    }

    let intervalId = setInterval(() => {
      if (stop === '' && this.timer.sec - 1 == -1) {
        this.timer.sec = 120;
      } else {
        --this.timer.sec;
      }

      // //console.log(intervalId)

      if (this.timer.sec == 0) {
        clearInterval(intervalId);
        // this.resendOtp()
      }
    }, 1000);

    return (this.timer.oldIntervalId = intervalId);
  }

  stopTimer() {
    if (this.keepOtpCountdown) {
      return;
    }
    this.startTimer(true);
  }

  isSignUpOtpFlow(): boolean {
    return (
      (localStorage.getItem('phone_login_type') || '').toLowerCase() ===
      'sign_up'
    );
  }

  resendOtp(mobile_number) {
    const source =
      this.mobileNumber || this.forgotPassMobileNumber || mobile_number;
    const cleanNumber = source
      ? source.toString().replace(/\D/g, '').slice(-10)
      : '';

    if (!cleanNumber || cleanNumber.length !== 10) {
      this.showErrorMsgSnackbar('Please enter a valid Mobile Number');
      return;
    }

    this.keepOtpCountdown = true;

    if (this.isSignUpOtpFlow()) {
      localStorage.setItem('phone_login_type', 'Sign_up');
      this.resendRegisterOtp(cleanNumber);
    } else {
      this.onClickSendOtpToMobile(cleanNumber);
    }
  }

  startOtpCountdown() {
    this.keepOtpCountdown = true;
    this.startTimer('');
  }

  resendRegisterOtp(mobile_number: string): void {
    const countryCode = this.registerForm?.value?.region || '+91';
    const fullMobile =
      this.mobileNumber ||
      this.forgotPassMobileNumber ||
      countryCode + mobile_number;
    const region =
      this.region === '+91' || !this.region ? 'IN' : this.region;
    const data = {
      email_id: fullMobile.startsWith('+') ? fullMobile : '+' + fullMobile.replace(/^\+/, ''),
      region,
      type: 'msisdn',
    };

    this.loadingService.showLoader();
    this.userService.resendOtp(data).subscribe(
      (response) => {
        this.loadingService.hideLoader();
        if (response?.error) {
          this.resendRegisterVerificationFallback(fullMobile, region);
          return;
        }
        this.showSuccessMsgSnackbar(
          response?.data?.message || 'OTP resent to your mobile number',
        );
        this.startOtpCountdown();
      },
      () => {
        this.resendRegisterVerificationFallback(fullMobile, region);
      },
    );
  }

  resendRegisterVerificationFallback(fullMobile: string, region: string): void {
    this.userService.resendRegisterVerification(fullMobile, region).subscribe(
      (response) => {
        this.loadingService.hideLoader();
        if (response?.error) {
          this.showErrorMsgSnackbar(
            response.error.message || 'Something went wrong. Please try again.',
          );
          return;
        }
        this.showSuccessMsgSnackbar(
          response?.data?.message || 'OTP resent to your mobile number',
        );
        this.startOtpCountdown();
      },
      (error) => {
        this.loadingService.hideLoader();
        this.showErrorMsgSnackbar(
          error.server_error_messsage ||
            'Something went wrong. Please try again.',
        );
      },
    );
  }

  resendOtpEmail(email) {
    // //console.log('resend otp starts', mobile_number);
    this.timer.sec = 120;
    this.onClickSendOtpToEmail(email);

    this.startTimer('');
  }

  showerrorSnackbarFormControl(formControl) {
    // //console.log(formControl.errors)
    if (formControl.errors.required) {
      this.snackbar.open(`Enter a valid Mobile Number`, '', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['red-snackbar'],
      });
    }
    if (formControl.errors.minlength) {
      this.snackbar.open(`Mobile number should be minimum of 10 digits`, '', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['red-snackbar'],
      });
    }
    if (formControl.errors.maxlength) {
      this.snackbar.open(
        `Mobile number should not be more than 10 digits`,
        '',
        {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['red-snackbar'],
        },
      );
    }
  }

  verifyCode() {
    // //console.log("verify code");
    let token =
      this.verifyToken.controls.in1.value +
      this.verifyToken.controls.in2.value +
      this.verifyToken.controls.in3.value +
      this.verifyToken.controls.in4.value +
      this.verifyToken.controls.in5.value +
      this.verifyToken.controls.in6.value;
    this.userService
      .getGenerateToken(this.session, token, this.region)
      .subscribe(
        (response: any) => {
          // //console.log("response: ", response);
          this.successFlag = true;
          this.verifyTokenForm.resetForm();

          setTimeout(
            function () {
              this.successFlag = false;
              this.router.navigate(['/']);
            }.bind(this),
            2500,
          );
        },
        (error: any) => {
          this.errorMessage = error.server_error_messsage;
          if (error.server_error_code === '1016') {
            this.sessionExpired();
          } else {
            this.errorFlag = true;
            setTimeout(
              function () {
                this.errorFlag = false;
              }.bind(this),
              4500,
            );
          }
        },
      );
  }

  keytab(e) {
    // if (/Mobi/.test(navigator.userAgent)) { //Mobile
    // e.target.nextElementSibling.focus();
    // } else { //Desktop

    if (e.key == 'Backspace') {
      if (e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }
    } else if (e.key.length == 1 && e.key !== ' ' && e.key.match(/[0-9]/)) {
      //  //console.log(e.key)
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }

    // }
  }

  ngAfterViewInit() {
    if (
      window.localStorage &&
      window.localStorage.getItem('retryToast') == 'true'
    ) {
      this.retryToast = true;
      setTimeout(
        function () {
          this.retryToast = false;
          window.localStorage.setItem('retryToast', 'false');
        }.bind(this),
        3000,
      );
    }
    this.startIdleWatch();
  }

  ngOnDestroy() {
    this.stopIdleWatch();
  }

  @HostListener('document:click')
  @HostListener('document:keydown')
  @HostListener('document:mousemove')
  @HostListener('document:scroll')
  @HostListener('document:touchstart')
  @HostListener('document:wheel')
  markUserActivity() {
    this.lastActivityAt = Date.now();
    this.idleLogoutFired = false;
  }

  @HostListener('document:visibilitychange')
  @HostListener('window:focus')
  onWindowBecameActive() {
    this.checkIdleTimeout();
  }

  startIdleWatch() {
    if (this.browser === 'android' || this.browser === 'ios') {
      return;
    }
    this.markUserActivity();
    this.stopIdleWatch();
    this.idleCheckTimer = setInterval(() => this.checkIdleTimeout(), 15000);
  }

  stopIdleWatch() {
    if (this.idleCheckTimer) {
      clearInterval(this.idleCheckTimer);
      this.idleCheckTimer = null;
    }
  }

  private isVideoPlaying(): boolean {
    const videos = document.querySelectorAll('video');
    for (let i = 0; i < videos.length; i++) {
      const video = videos[i] as HTMLVideoElement;
      if (!video.paused && !video.ended && video.currentTime > 0) {
        return true;
      }
    }
    return false;
  }

  checkIdleTimeout() {
    if (this.browser === 'android' || this.browser === 'ios') {
      return;
    }
    const hasSession = !!window.localStorage.getItem('otv_user_id') || !!this.session;
    if (!hasSession || this.idleLogoutFired || this.isSessionExpired) {
      return;
    }
    if (this.isVideoPlaying()) {
      this.lastActivityAt = Date.now();
      return;
    }
    if (Date.now() - this.lastActivityAt >= this.idleTimeoutMs) {
      this.idleLogoutFired = true;
      this.sessionExpired();
    }
  }

  //regionAutoDetect
  regionAutoDetect() {
    this.userService.autoRegion(this.region).subscribe(
      (resp) => {
        window.localStorage.setItem('regionDetails', JSON.stringify(resp));
        let oldRegion = window.localStorage.getItem('region');
        // //console.log(resp)
        this.region = resp['region'].country_code2;
        window.localStorage.setItem('portal_code', resp['region'].postal_code);
        window.localStorage.setItem('IPzip', JSON.stringify(resp['region']));
        //this.region = 'US';
        window.localStorage
          ? window.localStorage.setItem('region', this.region)
          : '';
        if (
          window.localStorage.getItem('otv_user_id') &&
          oldRegion &&
          oldRegion != this.region
        ) {
          if (this.browser == 'web') {
            this.fireRegionCheck();
          } else {
            androidRegionCheck();
          }
        }
        this.callingCode = resp['region'].calling_code.startsWith('00')
          ? '+' + resp['region'].calling_code.split('00')[1]
          : resp['region'].calling_code;
        this.defaultCountrycode = this.countryCodes.filter(
          (item) => item.code === this.region,
        )[0];
        // //console.log(this.defaultCountrycode);
        // this.userMobileLogin.get('login_mobile_code').setValue(this.defaultCountrycode)
        // this.userMobileRegister.get('register_mobile_code').setValue(this.defaultCountrycode)
        // this.userMobileForgot.get('frgt_pwd_mobile_code').setValue(this.defaultCountrycode)
        this.minPhnLimit = this.defaultCountrycode.min_limit;
        this.maxPhnLimit = this.defaultCountrycode.max_limit;
        if (this.region == 'IN') {
          let oldVal = this.userMobileLogin.get('sign_in_userid').value;
          this.userMobileLogin
            .get('sign_in_userid')
            .valueChanges.pipe()
            .subscribe((val) => {
              if (oldVal !== this.userMobileLogin.get('sign_in_userid').value) {
                this.showLoginOTP = false;
              }
            });
        } else {
          let oldVal = this.userEmailLogin.get('sign_in_userid').value;
          this.userEmailLogin
            .get('sign_in_userid')
            .valueChanges.pipe()
            .subscribe((val) => {
              if (oldVal !== this.userEmailLogin.get('sign_in_userid').value) {
                this.showLoginEmailOTP = false;
              }
            });
        }

        // //console.log(this.defaultCountrycode);
        // //console.log(this.region);
        // this.autoLogin('');
        // this.getUserDetails();
        if (this.region && window.localStorage) {
          window.localStorage
            ? window.localStorage.setItem('region', this.region)
            : '';
        }
        if (
          this.session &&
          this.browser !== 'ios' &&
          this.browser !== 'android'
        ) {
          this.userService.userDetails(this.session, this.region).subscribe(
            (user) => {
              //valid session

              this.loginStatus = true;
              this.userProfileDetails = user.data;
              this.isGDPIApproved = user.data?.gdpr_flag
                ? user.data?.gdpr_flag
                : false;
              window.localStorage
                ? window.localStorage.setItem(
                    'is_subscribed',
                    this.userProfileDetails?.is_subscribed,
                  )
                : '';
              // //console.log(this.userProfileDetails)
              this.userPlans('reload');
              this.getContinueWatching();
              // //console.log("session is valid");
            },
            (error: any) => {
              //invalid session
              this.loadingService.hideLoader();
              if (error.server_error_code === '1016' || error.server_error_messsage === 'Invalid User Id') {
                this.sessionExpired();
              }
            },
          );

          let date = new Date();
          let old_date =
            date.getMonth() +
            1 +
            '/' +
            date.getDate() +
            '/' +
            (date.getFullYear() - 18);
          this.maxDate = new Date(old_date);
        }

        if (this.session) {
          this.loginStatus = true;
          this.closeSwitchNetworkPopup = false;
        }
        //window.localStorage.removeItem("resetPasswordToast");

        this.getMenu();
        this.appConfigApi(true);
        //this.getUpcomingData()
      },
      (error: any) => {
        //invalid session
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
        // //console.log("autoDetact failed");
      },
    );
  }

  forgotpopup() {
    $('#signin_pop').modal('hide');
    $('#forgot_password_pop').modal('show');
  }

  forgotEmail() {
    const email = this.userForgotPassword.get('email')?.value;

    const data = {
      region: this.region,
      user_id: email,
      type: 'email',
    };

    this.plansService.forgotEmail(data, this.region).subscribe({
      next: (res) => {
        console.log('Success:', res);
        this.showSuccessMsgSnackbar('Reset link sent to your email');
        this.userForgotPassword.reset();
        this.closePop('forgotform');
        $('#forgot_password_pop').modal('hide');
        $('#signin_otp_pop_email').modal('show');
        this.forgot_pasword_email.setValue(email);

        window.localStorage.setItem('screen_from', 'forgot_email');
      },
      error: (err) => {
        console.error('Forgot password error:', err);
        this.showSuccessMsgSnackbar(err.error.error.message);
      },
    });
  }

  onClickMobileForgot(val) {
    const data = {
      region: this.region,
      user_id: '91' + val,
      type: 'msisdn',
    };

    this.plansService.forgotEmail(data, this.region).subscribe({
      next: (res) => {
        console.log('Success:', res);
        this.showSuccessMsgSnackbar('Reset link sent to your mobile number');
        this.userMobileLogin.reset();
        this.closePop('forgotform');
      },
      error: (err) => {
        console.error('Forgot password error:', err);
        this.showSuccessMsgSnackbar(err.error.error.message);
      },
    });
  }

  userPlans(type) {
    this.loadingService.showLoader();
    this.plansService.userPlans(this.session, this.region).subscribe(
      (user_plans_resp) => {
        this.loadingService.hideLoader();
        const activePlans = Array.isArray(user_plans_resp?.current_active_plans)
          ? user_plans_resp.current_active_plans
          : [];
        const title = activePlans[0]?.plan_title || '';
        window.localStorage.setItem('userType', title);
        // if(type == 'signIn'){
        //   npawPlugin().appAnalytics.newSession(null, {
        //     user_id: this.loginDetails.user_id,
        //     user_type: this.loginDetails.user_type,
        //     new_user: this.loginDetails.new_user,
        //     source: this.npawSource,
        //     content_id: this.npawContentId,
        //     platform: 'web'
        //   });
        //   npawPlugin().appAnalytics.fireEvent("Sign_In", {
        //     user_id: this.loginDetails.user_id,
        //     user_type: this.loginDetails.user_type,
        //     new_user: this.loginDetails.new_user,
        //     source: this.npawSource,
        //     content_id: this.npawContentId,
        //     platform: 'web'
        //   })
        // }
      },
      (error) => {
        this.loadingService.hideLoader();
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
      },
    );
  }

  sessionExpired() {
    this.loadingService.hideLoader();
    this.unblockUi();
    if (this.isSessionExpired) {
      return;
    }
    this.isSessionExpired = true;
    this.closePop('ctn_watch_delete_pop');
    if (window.localStorage.getItem('otv_user_id')) {
      this.commonService.removeOtvUserLocalStorage();
    }
    this.session = '';
    this.loginStatus = false;
    this.userProfileDetails = {};
    this.user = {};
    setTimeout(() => {
      this.unblockUi();
      $('#session_expired').modal('show');
    }, 50);
  }

  unblockUi() {
    this.loadingService.hideLoader();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open menu-open');
    $('body').css('overflow', '');
    $('body').css('padding-right', '');
  }

  clearInvalidSession() {
    this.closePop('my-profile_pop');
    this.closePop('session_expired');
    if (window.localStorage.getItem('otv_user_id')) {
      this.commonService.removeOtvUserLocalStorage();
    }
    this.session = '';
    this.loginStatus = false;
    this.userProfileDetails = {};
    this.user = {};
  }

  appConfigApi(enable) {
    if (this.browser != 'android') {
      this.userService.appConfig(this.region).subscribe(
        (response) => {
          this.termsAndConditionUrl =
            response['data']['params_hash2']['config_params']['web_pages'][
              'terms_conditions'
            ];
          this.loadingService.hideLoader();
          this.supportedRegion =
            response['data']['params_hash']['supported_regions_for_gdpr'];
          // let ads_available = response['data']['params_hash2']['config_params']['web_ads'] ? response['data']['params_hash2']['config_params']['web_ads']['ads_available'] : false;
          // window.localStorage.setItem('ads_available', ads_available);
          // window.localStorage.setItem('ad_slot1', JSON.stringify(response['data']['params_hash2']['config_params']['web_ads'][0]));
          // this.broadcastService.dispatch(new Message('ad_slot1', null));
if (window.innerWidth < 1200) {
         // if (screen.width < 1200) {
            window.localStorage
              ? window.localStorage.setItem(
                  'ad_slot1',
                  JSON.stringify(
                    response?.data?.params_hash2?.config_params?.mweb_ads,
                  ),
                )
              : '';
          } else {
            window.localStorage
              ? window.localStorage.setItem(
                  'ad_slot1',
                  JSON.stringify(
                    response?.data?.params_hash2?.config_params?.web_ads,
                  ),
                )
              : '';
          }
          window.localStorage
            ? window.localStorage.setItem(
                'banner_ads_available',
                JSON.stringify(response?.data?.banner_ads_available),
              )
            : '';

          if (response.data.sur_sangram_flag) {
            enable ? this.showSursangram() : '';
          } else {
            this.showSursangramPop = false;
          }
          // response.data['isZingPlayUser'] = false;
        },
        (error) => {
          //this.loadingIndicator = false;
          this.loadingService.hideLoader();
          ////console.log(error);
        },
      );
    }
  }

  refreshPage() {
    this.isSessionExpired = false;
    this.unblockUi();
    $('.modal').modal('hide');
    if (window.localStorage.getItem('otv_user_id')) {
      this.commonService.removeOtvUserLocalStorage();
    }
    this.session = '';
    this.loginStatus = false;
    // this.router.navigate(['/'])
    this.location.path() == ''
      ? window.location.reload()
      : this.router.navigate(['/']);
  }

  reloadAfterLogin() {
    window.location.reload();
  }

  // getUserDetails() {
  //   this.loadingService.showLoader();

  //   // this.userService.getUserDetailsLogin().subscribe(
  //     this.userService.userDetails(this.session, this.region).subscribe(
  //     (user) => {
  //       this.userProfileDetails = user.data;
  //       // //console.log(this.userProfileDetails)
  //       if(this.showChangeNumber === false){
  //         this.loadingService.hideLoader();
  //       }

  //       // this.onClickProfilePop()
  //       // if (user.data.is_9m_user) {
  //         // this.autoLogin(user.data.mobile_number);
  //       // } else {
  //         //this.showPop("retry_connecting", "");
  //         // this.commonService.removeOtvUserLocalStorage();
  //         // this.session = "";
  //         // this.loginStatus = false;
  //         // this.closeSwitchNetworkPopup = true;
  //       // }

  //     },
  //     (error: any) => {
  //       this.loadingService.hideLoader();
  //       if(error.server_error_code === "1016"){
  //         this.sessionExpired();
  //         // this.autoLogin('',);
  //       //  this.showErrorMsgSnackbar('You have been logged out, please sign in back')
  //       //  this.closePop('logout_pop');
  //       //  this.loginStatus = false;

  //       }
  //       // this.commonService.removeOtvUserLocalStorage();
  //       // this.session = "";
  //       // this.loginStatus = false;
  //       // this.router.navigate(['/']);
  //       // //console.log(error)
  //     })
  // };

  getContinueWatching() {
    this.loadingService.showLoader();
    if (this.session) {
      this.userService.getContinueWatching(this.session, this.region).subscribe(
        (data) => {
          this.loadingService.hideLoader();
          let continueWatchItem = data['data']['items'];
          this.continueWatchLength = continueWatchItem.length;
          for (var x = 0; x < continueWatchItem.length; x++) {
            continueWatchItem[x]['itemURL'] = this.commonService.getItemURL(
              continueWatchItem[x],
            );
            // //console.log(this.continueWatchItem[x]['itemURL']);
          }
          if (window.localStorage) {
            window.localStorage.setItem(
              'continueWatchItems',
              JSON.stringify(continueWatchItem),
            );
          }
          this.broadcastService.dispatch(
            new Message(
              'continueWatchItem',
              continueWatchItem.total_items_count,
            ),
          );
        },
        (error) => {
          // //console.log(error);
          this.loadingService.hideLoader();
          if (error.server_error_code === '1016') {
            this.sessionExpired();
          }
        },
      );
    }
  }

  initializeForms() {
    this.verifyToken = this.fb.group({
      in1: new FormControl('', Validators.required),
      in2: new FormControl('', Validators.required),
      in3: new FormControl('', Validators.required),
      in4: new FormControl('', Validators.required),
    });

    this.verifyTokenEmail = this.fb.group({
      in1: new FormControl('', Validators.required),
      in2: new FormControl('', Validators.required),
      in3: new FormControl('', Validators.required),
      in4: new FormControl('', Validators.required),
    });

    this.userMobileLogin = this.fb.group({
      sign_in_userid: new FormControl('', [Validators.required]),
    });

    this.userEmailLogin = this.fb.group({
      sign_in_userid: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]),
      ),
    });

    //   this.userMobileLogin = this.fb.group({
    //     login_mobile_code: new FormControl('', Validators.required),
    //     login_mobile: new FormControl('', Validators.required),
    //     user_mob_password: new FormControl('', [ Validators.required, Validators.minLength(6)])
    //   });

    // this.userEmailRegister = this.fb.group({
    //   user_register_mobile: new FormControl('', [Validators.required, Validators.minLength(13), Validators.maxLength(13)]),
    //   user_register_name: new FormControl('',),
    //   user_register_email: new FormControl(''),
    //   // /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[@#$%^&*()_+=!-])(?=.{8,})/g
    //   // ^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#\$%\^\&*\)\(+=_-])[A-Za-z\d!@#\$%\^\&*\)\(+=_-]{8,}$
    //   // /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=_-]{8,}$/g
    //   user_register_password: new FormControl('', [Validators.required, Validators.minLength(8) , Validators.pattern('^(?=[^A-Za-z]*[A-Za-z])(?=\\D*\\d)(?=[^!@#\\$%\\^\\&*\\)\\(+=_-]*[!@#\\$%\\^\\&*\\)\\(+=_-])[A-Za-z\\d!@#\\$%\\^\\&*\\)\\(+=_-]{8,}$')]),
    //   user_register_confirm_password: new FormControl('',[Validators.required, Validators.minLength(8)]),
    //   // register_name: new FormControl('', Validators.required),
    //   // register_password: new FormControl('', [ Validators.required, Validators.minLength(6)]),
    //   email_agree_terms: new FormControl('', Validators.required)
    // },
    //   { validator: MustMatch('user_register_password', 'user_register_confirm_password') }
    // )

    this.userProfile = this.fb.group({
      user_profile_name: new FormControl('', [
        Validators.pattern('^[A-Za-z ]+$'),
      ]),
      user_profile_mobileNo: new FormControl(''), 
      user_profile_email: new FormControl('', [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'),
      ]),
      user_profile_age: new FormControl(''),
    });
    this.registerForm = this.fb.group({
      region: new FormControl('+91', [Validators.required]),
      email_id: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$'),
      ]),
      user_email_id: new FormControl('', [
        Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$'),
      ]),
      firstname: new FormControl(''),
    });

    // this.userMobileRegister = this.fb.group({
    //   mob_register_name: new FormControl('', Validators.required),
    //   register_mobile_code: new FormControl('', Validators.required),
    //   user_register_mobile: new FormControl('', Validators.required),
    //   mob_register_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    //   phone_agree_terms: new FormControl(false, Validators.required),
    //   registerMobileOTP: new FormControl('', [Validators.required, Validators.minLength(4)])
    // })

    //   this.UserEmailForgotPassword =this.fb.group({
    //     frgt_pwd_email_id: new FormControl('', Validators.compose([Validators.required, Validators.email]))
    //   })

    // this.userMobileForgot = this.fb.group({
    //   frgt_pwd_mobile_no: new FormControl({ value: '', disabled: false }, Validators.required),
    //   //  frgt_pwd_mobile_btn: new FormControl('',[Validators.required]),
    //   // frgt_pwd_otp: new FormControl({value: '', disabled: false}, [ Validators.required, Validators.minLength(4)])
    // })
    // this.userIdForgot = this.fb.group({
    //   frgt_userid_mobile_no: new FormControl('', [Validators.required, Validators.minLength(13), Validators.maxLength(13)])
    // })
    this.getUserid = this.fb.group({
      userid_inputfeild: new FormControl(''),
    });

    //   this.updateUser = this.fb.group({
    //     user_profile_name: new FormControl(''),
    //     user_mobile_number: new FormControl('', [Validators.minLength(10), Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    //     user_email_address: new FormControl('', Validators.email),
    //     user_address: new FormControl(''),
    //     user_state: new FormControl(''),
    //     user_country: new FormControl(''),
    //     datepicker: new FormControl('')
    //   })

    //   this.changePassword = this.fb.group({
    //     old_change_password: new FormControl('', [ Validators.minLength(6), Validators.required]),
    //     new_change_password: new FormControl('', [ Validators.minLength(6), Validators.required]),
    //     new_change_confirm_password: new FormControl('', [ Validators.minLength(6), Validators.required])
    //   }, {
    //     validator: MustMatch('new_change_password', 'new_change_confirm_password')
    //   })

    // this.userResetPassword = this.fb.group({
    //   reset_password: new FormControl('', [Validators.minLength(8) , Validators.pattern('^(?=[^A-Za-z]*[A-Za-z])(?=\\D*\\d)(?=[^!@#\\$%\\^\\&*\\)\\(+=_-]*[!@#\\$%\\^\\&*\\)\\(+=_-])[A-Za-z\\d!@#\\$%\\^\\&*\\)\\(+=_-]{8,}$')]),
    //   reset_confirm_password: new FormControl('', [Validators.required,Validators.minLength(8) ])
    // }, {
    //   validator: MustMatch('reset_password', 'reset_confirm_password')
    // })

    // this.socialAuthService.authState.subscribe((user) => {
    //   this.socialLoginUserDetails = user;
    //   this.isSignedin = (user != null);
    //   //console.log(this.socialLoginUserDetails);
    //   this.socialLoginInit(this.socialLoginUserDetails);
    //   // });

    // this.userEmailConfirmLogin = this.fb.group({
    //   login_email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
    //   login_email_password: new FormControl('', [Validators.required, Validators.minLength(6)])
    // });

    //   this.backendMessageStatus = false;
    this.formGroupGDPI = this.fb.group({
      cb: [false, Validators.requiredTrue],
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  numberOnlyForInternationalUsers(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  reload() {
    window.location.reload();
  }

  showPop(popId: string, prev_popup_type: string) {
    /* Show Pop up */
    // //console.log("popId"+popId);
    $('.modal').modal('hide');
    $('#' + popId).modal('show'); //to open the selected popup
    this.errorStatus = false;
    if (popId == 'search_pop') {
      if ($('#tarangpluser')[0] && $('#tarangpluser')[0].hasAttribute('src')) {
        // window.postMessage("banner_pause", "*");
        this.broadcastService.dispatch(new Message('stopBannerTrailer', null));
      }
      // this.broadcastService.dispatch(new Message('recentsearch', null));
      this.analytics.logEvent('app_event_click', {
        e_v: 1,
        typ: 'search',
        vst: 'search',
        app: 'web',
        s_q: '',
        e_t: 'click',
        title: 'search',
        u_st: window.localStorage.getItem('otv_user_analytic_id')
          ? 'registered'
          : 'anonymous',
        u_p_r: 'NA',
        u_p: 'NA',
        u_id: window.localStorage.getItem('otv_user_analytic_id'),
        platform: this.browser,
      });
      this.analytics.logEvent('app_event_page_visit', {
        e_v: 1,
        typ: 'search',
        vst: 'search_page',
        app: 'web',
        s_q: '',
        e_t: 'page_visit',
        title: 'search',
        u_st: window.localStorage.getItem('otv_user_analytic_id')
          ? 'registered'
          : 'anonymous',
        u_p_r: 'NA',
        u_p: 'NA',
        u_id: window.localStorage.getItem('otv_user_analytic_id'),
        platform: this.browser,
      });
      this.broadcastService.dispatch(new Message('bannerAds', null));
    } else if (popId == 'my-profile_pop') {
      this.analytics.logEvent('app_event_click', {
        e_v: 1,
        typ: 'profile',
        vst: 'profile',
        app: 'web',
        s_q: '',
        e_t: 'click',
        title: 'profile',
        u_st: window.localStorage.getItem('otv_user_analytic_id')
          ? 'registered'
          : 'anonymous',
        u_p_r: 'NA',
        u_p: 'NA',
        u_id: window.localStorage.getItem('otv_user_analytic_id'),
        platform: this.browser,
      });
    }

    // if(popId === 'forgot_password_pop' || popId === 'forgot_userid_pop'|| popId === 'profile_pop'){
    //   this.verifyTokenForm.resetForm();
    // }

    if (popId === 'signin_pop') {
      if ($('#tarangpluser')[0] && $('#tarangpluser')[0].hasAttribute('src')) {
        this.broadcastService.dispatch(new Message('stopBannerTrailer', null));
        // window.postMessage("banner_pause", "*");
      }
      this.keepOtpCountdown = false;
      this.mobileNumber = '';
      this.stopTimer();
      this.showLoginOTP = false;
      this.verifyToken?.reset();
      // this.stopTimer()
    }

    if (popId == 'signin_email_pop') {
      if ($('#tarangpluser')[0] && $('#tarangpluser')[0].hasAttribute('src')) {
        this.broadcastService.dispatch(new Message('stopBannerTrailer', null));
        // window.postMessage("banner_pause", "*");
      }
      this.verifyTokenEmail.reset();
      // this.stopTimer()
    }

    if (prev_popup_type == 'loginform') {
      if (this.userMobileLogin != undefined) {
        this.mobileLoginForm.resetForm();
      }

      this.countryCodeStatus = false;

      $('#signin_pop').modal('hide');
    }

    if (prev_popup_type == 'loginemailform') {
      if (this.userEmailLogin != undefined) {
        this.emailLoginForm.resetForm();
      }

      this.countryCodeStatus = false;

      $('#signin_email_pop').modal('hide');
    }

    // if (prev_popup_type == 'forgotpasswordotpform') {
    //   $('#forgot_password_otp_pop').modal('hide');
    // };

    if (prev_popup_type == 'forgotuseridotpform') {
      $('#forgot_userid_otp_pop').modal('hide');
    }
    if (prev_popup_type == 'finduseridform') {
      $('#find_userid_pop').modal('hide');
    }

    // if (prev_popup_type == 'signInRequired' && popId == 'register_pop') {
    if (prev_popup_type == 'signInRequired') {
      this.closeSwitchNetwork();
      $('#closeSwitch-Network-PopUp').modal('hide');
    }
    if (prev_popup_type == 'signInRequired' && popId == 'signin_pop') {
      this.closeSwitchNetwork();
      $('#closeSwitch-Network-PopUp').modal('hide');
    }

    if (popId === 'my-profile_pop') {
      this.userDetails(true);
    }

    if (prev_popup_type == 'accountDetailsForm') {
      this.countryCodeStatus = false;
    }

    // if(popId === 'profile_pop'){
    //   this.getUserDetails();
    //   if(this.session){
    //     this.onClickProfilePop()
    //   }

    // }

    // if(popId === 'profile_pop' && prev_popup_type === 'update-number'){
    //   this.userProfile.get('user_profile_mobileNo').setValue(this.otpMobileValue)
    //   this.showChangeNumber = false;
    //   this.showProfileUpdateOtp = true;

    // }
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // loginPopup(){
  // this.npawContentId = JSON.parse(window.localStorage.getItem('catalogObj')).content_id;
  // this.npawSource = 'utm:'+window.location.href;
  // this.loginBasedonRegion();
  // }

  loginBasedonRegion() {
    this.region = window.localStorage.getItem('region');
    this.closePop('signInRequired');
    if (this.region == 'IN') {
      this.showLogin();
    } else {
      this.showEmailLogin();
    }
    $('#region_change_pop').modal('hide');
    // this.isSessionExpired = true;
    this.showDiffRegionPop = false;
  }

  closePop(popupType: string) {
    /* Close Pop up */
    this.statusMessage = '';
    this.errorStatus = false;
    if (popupType === 'signin_otp_pop' || popupType === 'signin_otp_pop_email') {
      this.keepOtpCountdown = false;
    }
    this.stopTimer();
    $('.modal').modal('hide');
    // //console.log(popupType);
    if (popupType == 'emailpop') {
      this.userEmailPasswordLogin.reset();
      this.userForgotPassword.reset();
      this.userMobileLogin.reset();
    }
    if (popupType == 'forgotForm') {
      this.userMobileLogin.reset();
      this.userForgotPassword.reset();
    }
    if (popupType) {
      this.clearAllFields();
    }
    // this.initializeForms();
    if (popupType == 'loginform' || popupType == 'forgotpasswordotpform') {
      this.showLoginOTP = false;
      //  //console.log(this.userEmailLogin.controls.sign_in_userid.errors)

      this.countryCodeStatus = false;
    }

    if (
      popupType == 'loginemailform' ||
      popupType == 'forgotpasswordotpformemail'
    ) {
      this.showLoginEmailOTP = false;
      //  //console.log(this.userEmailLogin.controls.sign_in_userid.errors)

      this.countryCodeStatus = false;
    }

    if (popupType == 'forgotpasswordotpform') {
      this.verifyToken.reset();
    }

    if (popupType == 'forgotpasswordotpformemail') {
      this.verifyTokenEmail.reset();
    }

    if (popupType == 'logoutform') {
      this.countryCodeStatus = false;
    }

    if (popupType == 'deleteWatchHistory') {
      this.countryCodeStatus = false;
    }

    // sign in req popup
    if (popupType == 'signInRequired') {
      this.closeSwitchNetworkPopup = false;
      $('#closeSwitch-Network-PopUp').modal('hide');
      // //console.log("signInRequired");
    }

    if (popupType == 'user_updatedetails_otp') {
      this.verifyTokenForm.resetForm();
      $('#update_otp_verify').modal('hide');
    }

    if (popupType === 'profileform' || popupType == 'user_updatedetails_otp') {
      this.userProfile.reset();
      this.showUpdateProfile = false;
      // this.feild_editable = true;
    }

    $('.modal-backdrop.show').hide();
  }

  clearAllFields() {
    this.userMobileLogin.reset();
    this.userEmailLogin.reset();
  }

  onClickProfilePop() {
    this.userProfile.controls.user_profile_name.setValue(
      this.user.firstname,
    );
    this.userProfile.controls.user_profile_mobileNo.setValue(
      this.user.mobile_number,
    );
    this.userProfile.controls.user_profile_email.setValue(
      this.user.email_id,
    );
    this.userProfile.controls.user_profile_age.setValue(
      Number(this.user.age),
    );
  }

  onToggleChange(event: Event) {
    const toggleSwitch = event.target as HTMLInputElement;

    if (!toggleSwitch.checked) {
      // If the toggle is being unchecked, show confirmation popup
      this.isParentalControlEnabled = true;
      toggleSwitch.checked = true;
      this.showConfirmationPopup();
    } else {
      // Enable parental lock directly
      this.updateParentalControl(toggleSwitch.checked);
    }
  }

  showConfirmationPopup() {
    // Display the confirmation popup
    const popup = document.getElementById('parentak-popup');
    if (popup) {
      popup.style.display = 'block';
    }
  }

  setLoginType(type: 'mobile' | 'email') {
    this.loginTypes = type;
  }

  closeConfirmationPopup() {
    const popup = document.getElementById('parentak-popup');
    if (popup) {
      popup.style.display = 'none';
    }
  }

  disableParentalLock() {
    // Proceed to disable parental lock
    this.isParentalControlEnabled = false;
    this.updateParentalControl(false);
    this.closeConfirmationPopup();
  }

  updateParentalControl(isEnabled: boolean) {
    // Save the updated state to localStorage
    localStorage.setItem('parentalControl', isEnabled.toString());
    localStorage.setItem('redirectToHome', 'true');

    if (!this.session) {
      const message = isEnabled
        ? 'Parental control is On!'
        : 'Parental control is Off!';
      this.showSuccessMsgSnackbar(message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return;
    }

    // Prepare payload with only parental_control field
    const data = {
      auth_token: '3zZmzoHg8z6SM3wpDoyw',
      user: {
        parental_control: isEnabled ? 'true' : 'false',
      },
    };

    this.loadingService.showLoader();
    this.userService.getUpdateUserData(data, this.session).subscribe(
      (result) => {
        this.loadingService.hideLoader();
        if (!result.error) {
          const message = isEnabled
            ? 'Parental control is On!'
            : 'Parental control is Off!';
          this.showSuccessMsgSnackbar(message);

          // Hard refresh the page
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      },
      (error) => {
        this.loadingService.hideLoader();
        this.showErrorMsgSnackbar(
          error.server_error_messsage ||
            'Failed to update parental control. Try again!',
        );
      },
    );
  }

  onclickUpdateUserProfile() {
    // //console.log(this.userProfile)
   // this.userDetails();
    // this.loadingService.showLoader();

    if (this.session) {
      let data = {
        auth_token: '3zZmzoHg8z6SM3wpDoyw',
        user: {
          user_email_id: this.userProfile.controls.user_profile_email.value,
          mobile_number: this.userProfile.controls.user_profile_mobileNo.value,
          firstname: this.userProfile.controls.user_profile_name.value,
          age: this.userProfile.controls.user_profile_age.value,
        },
      };

      this.loadingService.showLoader();
      this.userService.getUpdateUserData(data, this.session).subscribe(
        (result) => {
          // //console.log(result);
          this.loadingService.hideLoader();
          if (!result.error) {
            this.showSuccessMsgSnackbar('Changes saved successfully!');
            this.userDetails();
            this.showUpdateProfile = false;
            try {
              if (typeof webengage !== 'undefined' && webengage?.track) {
                const beforeName = (this.user?.firstname ?? '')
                  .toString()
                  .trim();
                /*const beforeEmail = (
                  this.userProfileDetails?.user_email_id ??
                  this.userProfileDetails?.email_id ??
                  ''
                )*/
               const beforeEmail = (
  this.user?.user_email_id ??
  this.user?.email_id ??
  ''
)


                  .toString()
                  .trim();
              /* const beforeMobile = (
                  thi*/
                  const beforeMobile = (
  this.user?.mobile_number ?? ''
)
                  .toString()
                  .trim();
                const beforeAge = (this.user?.age ?? '')
                  .toString()
                  .trim();

                const afterName = (
                  this.userProfile?.controls?.user_profile_name?.value ?? ''
                )
                  .toString()
                  .trim();
                const afterEmail = (
                  this.userProfile?.controls?.user_profile_email?.value ?? ''
                )
                  .toString()
                  .trim();
                const afterMobile = (
                  this.userProfile?.controls?.user_profile_mobileNo?.value ?? ''
                )
                  .toString()
                  .trim();
                const afterAge = (
                  this.userProfile?.controls?.user_profile_age?.value ?? ''
                )
                  .toString()
                  .trim();

                const fields_updated: string[] = [];
                if (afterName && afterName !== beforeName)
                  fields_updated.push('name');
                if (afterEmail && afterEmail !== beforeEmail)
                  fields_updated.push('email');
                if (afterMobile && afterMobile !== beforeMobile)
                  fields_updated.push('mobile_number');
                if (afterAge && afterAge !== beforeAge)
                  fields_updated.push('age');

                const payload = {
                  country: '-',
                  Email: '-',
                  device_model: '-',
                  Address: '-',
                  app_version: '-',
                  city: '-',
                  Email_ID: '-',
                  os_version: '-',
                  fields_updated,
                  'Email id': '-',
                  ua: '-',
                  platform: '-',
                  Name: '-',
                  source_screen: 'profile_screen',
                  phone: '-',
                  user_id: '-',
                  Phone: '-',
                  State: '-',
                  DOB: '-',
                  Country: '-',
                  state: '-',
                  network_type: '-',
                  Age: '-',
                  age: '-',
                };
                console.log('WebEngage Account Details Updated', payload);
                webengage.track('Account Details Updated', payload);
              }
            } catch {
              /* non-fatal analytics */
            }
          }
        },
        (error) => {
          this.loadingService.hideLoader();
          // //console.log(error)
          if (error.server_error_code === '1016') {
            this.sessionExpired();
          } else if (error.server_error_code !== 500) {
            this.userProfile.controls.user_profile_mobileNo.setValue(
              this.userProfileDetails.mobile_number,
            );
            this.showChangeNumber = false;
            this.showChangeEmail = false;
            this.showChangeName = false;
            this.showErrorMsgSnackbar(error.server_error_messsage);
          } else {
            this.showErrorMsgSnackbar('Try again!!!');
          }
        },
      );
    }
  }

  onClickSendOtpToMobile(mobile_number) {
    if (mobile_number && mobile_number.toString().length === 10) {
      const data = {
        email_id: '+91' + mobile_number,
        // "email_id":this.callingCode.split('+')[1] +mobile_number,
        region: this.region,
        type: 'msisdn',
      };
      localStorage.setItem('phone_login_type', 'login');
      //integrate api to get OTP and activate next button

      // //console.log(data);
      this.loadingService.showLoader();
      this.userService.getLoginOtp(data).subscribe(
        (result) => {
          ////console.log(result)
          this.loadingService.hideLoader();
          if (!result.error) {
            this.showSuccessMsgSnackbar(result.data.message);
            const countryCode = this.callingCode || '+91';
            this.mobileNumber = countryCode + mobile_number;
            this.forgotPassMobileNumber = countryCode + ' ' + mobile_number;
            this.forgot_pasword_mobile.setValue(mobile_number);
            $('#signin_otp_pop').modal('show');
            this.stopTimer();
            this.startTimer('');
            this.showLoginOTP = true;
          } else {
            const apiMsg =
              typeof result.error === 'string'
                ? result.error
                : result.error?.message;
            this.showErrorMsgSnackbar(
              apiMsg || 'Something went wrong. Please try again.',
            );
          }
        },
        (error) => {
          this.loadingService.hideLoader();
          if (error.server_error_code === '1016') {
            this.sessionExpired();
          }
          this.showErrorMsgSnackbar(
            error.server_error_messsage ||
              'Something went wrong. Please try again.',
          );
        },
      );
    } else {
      //  this.showErrorMsgSnackbar('Please fill all required fields')
      this.showErrorMsgSnackbar('Please enter a valid Mobile Number');
    }
  }

  onClickEmail() {
   //debugger;

    if (this.userEmailPasswordLogin.invalid) {
      this.userEmailPasswordLogin.markAllAsTouched();

      const emailControl = this.userEmailPasswordLogin.get('email');
      const passwordControl = this.userEmailPasswordLogin.get('password');

      if (emailControl?.errors?.required || emailControl?.errors?.email) {
        this.showErrorMsgSnackbar('Please enter a valid email address');
      } else if (passwordControl?.errors?.required) {
        this.showErrorMsgSnackbar('Password cannot be blank');
      } else if (passwordControl?.errors?.minlength) {
        this.showErrorMsgSnackbar('Password must be at least 6 characters');
      } else {
        this.showErrorMsgSnackbar('Please fill all required fields');
      }
      return;
    }

    const email = this.userEmailPasswordLogin.get('email')?.value;
    const password = this.userEmailPasswordLogin.get('password')?.value;

    const data = {
      auth_token: '3zZmzoHg8z6SM3wpDoyw',
      user: {
        password: password,
        region: this.region,
        email_id: email,
        type: 'email',
      },
    };

    this.userService.getEmail(data).subscribe(
      (result) => {
        if (!result.error) {
          this.showSuccessMsgSnackbar('Signed In Successfully!');
          this.getLocation();
          this.closePop('signin_google_pop');

          // Store the login details
          const loginDetails = result.data;
          // this.gdprFlag = response.gdpr_flag;
          this.gdprFlag = result.gdpr_flag ?? false;
          localStorage.setItem('gdpr_flag', this.gdprFlag.toString());
          this.signed_emailid = result.data.email_id;
          window.localStorage.setItem('signed_emailid', this.signed_emailid);
          this.loginStatus = true;
          this.user_det = {
            status: true,
            user_id: loginDetails.session,
            user_name: loginDetails.firstname,
            user_signin_id: loginDetails.user_id,
            user_login_type: loginDetails.login_type,
            user_analy_id: loginDetails.user_id,
            user_subscribed: loginDetails.new_user,
          };

          this.commonService.setOtvUserLocalStorage(this.user_det);
          this.userDetails();

          if (loginDetails?.new_user) {
            const payload = {
              registration_method: 'email',
              mobile_number_provided: !!loginDetails?.mobile_number,
              ...this.userRegisteredContext(false, loginDetails),
            };
            console.log('WebEngage User Registered', payload);
            webengage.track('User Registered', payload);
          }

          this.saranyu_login(
            loginDetails.user_id,
            'email',
            result.data.email_id,
            'login_success',
          );
        } else {
          this.showErrorMsgSnackbar(result.error.message);
          const errorMessage = result?.error?.message || '';
          console.log('Tracking Signup Failure', errorMessage);
          webengage.track('Signup Failure', {
            failure_step: 'mobile_entry',
            failure_reason: errorMessage,
            registration_method_attempted: 'email',
          });
        }
      },
      (error) => {
        this.loadingService.hideLoader();
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
        this.showErrorMsgSnackbar(
          error.server_error_messsage ||
            'Something went wrong. Please try again.',
        );
      },
    );
  }

  onClickSendOtpToEmail(email_id) {
    if (this.userEmailLogin.valid) {
      const data = {
        email_id: email_id,
        region: this.region,
        type: 'email',
      };
      //integrate api to get OTP and activate next button

      // //console.log(data);
      this.loadingService.showLoader();

      this.userService.getLoginOtp(data).subscribe(
        (result) => {
          ////console.log(result)
          this.loadingService.hideLoader();
          if (!result.error) {
            this.showSuccessMsgSnackbar(result.data.message);
            $('#signin_otp_pop_email').modal('show');
            this.stopTimer();
            this.startTimer('');
            this.showLoginEmailOTP = true;
            this.forgot_pasword_email.setValue(email_id);
          } else {
            const apiMsg =
              typeof result.error === 'string'
                ? result.error
                : result.error?.message;
            this.showErrorMsgSnackbar(
              apiMsg || 'Something went wrong. Please try again.',
            );
          }
        },
        (error) => {
          this.loadingService.hideLoader();
          if (error.server_error_code === '1016') {
            this.sessionExpired();
          }
          this.showErrorMsgSnackbar(
            error.server_error_messsage ||
              'Something went wrong. Please try again.',
          );
        },
      );
    } else {
      //  this.showErrorMsgSnackbar('Please fill all required fields')
      this.showErrorMsgSnackbar('Please enter a valid Email Id');
    }
  }

  onClickLogin(popId) {
    //  this.mobileNumber = '';
    // const mobile_number = this.callingCode.split("+")[1] + this.userMobileLogin.controls.sign_in_userid.value;

    ////console.log("verify code");
    // //console.log(this.userMobileLogin,"---------------")
    // const mobile_number =this.callingCode.split("+")[1]+ this.userMobileLogin.controls.sign_in_userid.value
    // register page reusable
    const mobile_number =
      this.mobileNumber ||
      this.callingCode.split('+')[1] +
        this.userMobileLogin.controls.sign_in_userid.value;
    let token =
      this.verifyToken.controls.in1.value +
      this.verifyToken.controls.in2.value +
      this.verifyToken.controls.in3.value +
      this.verifyToken.controls.in4.value;
    if (token.length === 4) {
      //integrate api for login and change UI if login is successfull
      this.loadingService.showLoader();
      this.userService.loginwithOtp(token, mobile_number).subscribe(
        (result) => {
          //  //console.log(result,"result------------------")
          this.loadingService.hideLoader();
          if (!result.error) {
            // this.showPop('free_trial_popup','')
            this.showSuccessMsgSnackbar('Signed In Successfully!');
            this.getLocation();
            this.closePop('signin_otp_pop');
            var userId = result['data']['session_id'];
            this.loginDetails = result.data;
            this.loginStatus = true;
            this.user_det = {
              status: true,
              user_id: userId,
              user_name: '',
              user_signin_id: result.data.user_id,
              user_login_type: result.data.login_type,
              // user_login_id: user["data"]["primary_id"],
              user_analy_id: result.data.user_id,
              user_subscribed: result.data.is_subscribed,
              // user_sub_st: user['data']['is_subscribed']
            };
            this.showLoginOTP = false;
            this.commonService.setOtvUserLocalStorage(this.user_det);
            if (window.localStorage) {
              this.session = window.localStorage.getItem('otv_user_id');
            }
            this.userDetails();
            //  this.analytics.logEvent('signup_success', {
            //    method: 'phone',
            //    u_id: window.localStorage.getItem('otv_user_analytic_id'),
            //    platform: this.browser,
            //  });

            const isPhoneLoginOnly =
              localStorage.getItem('phone_login_type') == 'login';
            // Track registration for signup flow OR first-time users who used login OTP.
            if (!isPhoneLoginOnly || result.data?.new_user) {
              const payload = {
                registration_method: 'mobile_otp',
                mobile_number_provided: true,
                ...this.userRegisteredContext(true, result.data, {
                  email: this.registerForm?.value?.user_email_id,
                  name: this.registerForm?.value?.firstname,
                }),
              };
              console.log('WebEngage User Registered', payload);
              webengage.track('User Registered', payload);
            }

            if (localStorage.getItem('phone_login_type') == 'login') {
              this.saranyu_login(
                result.data.user_id,
                'phone',
                mobile_number,
                'login_success',
              );
            } else {
              this.saranyu_login(
                result.data.user_id,
                'phone',
                mobile_number,
                'signup_success',
              );
            }

            this.userPlans('signIn');
            this.getContinueWatching();
            this.reloadAfterLogin();
          }
        },
        (error) => {
          this.loadingService.hideLoader();
          this.showErrorMsgSnackbar(
            error.server_error_messsage === 'Otp Expired'
              ? error.server_error_messsage
              : 'Invalid OTP',
          );
          if (localStorage.getItem('phone_login_type') != 'login') {
            try {
              const prev = parseInt(
                sessionStorage.getItem(PB_SIGNUP_OTP_FAILURE_COUNT) || '0',
                10,
              );
              sessionStorage.setItem(
                PB_SIGNUP_OTP_FAILURE_COUNT,
                String((Number.isNaN(prev) ? 0 : prev) + 1),
              );
            } catch {
              /* ignore */
            }
          }
          this.analytics.logEvent('signup_failure', {
            error_type: error.server_error_messsage,
            method: 'phone',
            u_id: window.localStorage.getItem('otv_user_analytic_id'),
            platform: this.browser,
          });
          console.log('Tracking Signup Failure');
          const otpAttemptNumber = 1 + (parseInt(
            sessionStorage.getItem(PB_SIGNUP_OTP_FAILURE_COUNT) || '0',
            10,
          ) || 0);
          webengage.track('Signup Failure', {
            failure_step: 'otp_entry',
            failure_reason:
              error.server_error_messsage === 'Otp Expired'
                ? 'otp_failed'
                : 'otp_failed',
            registration_method_attempted: 'mobile_otp',
            error_code: error.server_error_code || 'NA',
            attempt_number: otpAttemptNumber,
          });
          this.saranyu_signup_failure(
            window.localStorage.getItem('otv_user_analytic_id'),
            'phone',
            error.server_error_messsage,
          );

          // this.showErrorMsgSnackbar(error.server_error_messsage);
          ////console.log(error)
        },
      );
    } else {
      this.snackbar.open('Please fill all required fields', '', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['red-snackbar'],
      });
    }
  }

  saranyu_signup_failure(user, method, error) {
    let data = {
      method: method,
      u_id: user,
      platform: 'web',
      event_name: 'signup_failure',
      environment: environment.envType,
      error_type: error,
      app_version: 'NA',
      device_brand: 'NA',
      device_model: 'NA',
      device_id: 'NA',
      network_type: this.browser == 'web' ? 'Wifi' : 'Mobile data',
      os_version: 'NA',
      country: window.localStorage.getItem('region').toLowerCase(),
      device_type: this.deviceType,
      screen_size: `${window.screen.width}*${window.screen.height}`,
      city: (window.localStorage.IPzip
        ? JSON.parse(
            window.localStorage.getItem('IPzip'),
          ).city_name.toLowerCase()
        : 'NA'
      ).toLowerCase(),
      state: (window.localStorage.IPzip
        ? JSON.parse(window.localStorage.getItem('IPzip'))?.state?.toLowerCase()
        : 'NA'
      ).toLowerCase(),
      ip: window.localStorage.IPzip
        ? JSON.parse(window.localStorage.getItem('IPzip')).ip
        : 'NA',
      subscription_status: window.localStorage.user
        ? JSON.parse(window.localStorage.user).is_subscribed
          ? 'Active'
          : 'Inactive'
        : 'NA',
      user_state: window.localStorage.user_state
        ? window.localStorage.user_state
        : 'NA',
      postal_code: window.localStorage.postal_code
        ? window.localStorage.postal_code
        : 'NA',
      event_time: new Date().toISOString().slice(0, 19),
    };
    this.userService.analytics(data).subscribe((response) => {});
  }

  saranyu_login(user, method, login_data, event) {
    let ipzip: any = {};
    try {
      ipzip = JSON.parse(window.localStorage.getItem('IPzip') || '{}') || {};
    } catch (e) {
      ipzip = {};
    }
    let userObj: any = {};
    try {
      userObj = JSON.parse(window.localStorage.getItem('user') || '{}') || {};
    } catch (e) {
      userObj = {};
    }
    const region = (window.localStorage.getItem('region') || 'IN').toLowerCase();

    let data = {
      method: method,
      u_id: user,
      platform: 'web',
      event_name: event,
      environment: environment.envType,
      phone_number: login_data,
      app_version: 'NA',
      device_brand: 'NA',
      device_model: 'NA',
      device_id: 'NA',
      network_type: this.browser == 'web' ? 'Wifi' : 'Mobile data',
      os_version: 'NA',
      country: region,
      device_type: this.deviceType,
      screen_size: `${window.screen.width}*${window.screen.height}`,
      city: (ipzip?.city_name
        ? String(ipzip.city_name).toLowerCase()
        : 'na'
      ).toLowerCase(),
      state: (ipzip?.state
        ? String(ipzip.state).toLowerCase()
        : 'na'
      ).toLowerCase(),
      ip: ipzip?.ip || 'NA',
      subscription_status: userObj?.is_subscribed ? 'Active' : 'Inactive',
      user_state: window.localStorage.getItem('user_state') || 'NA',
      postal_code: window.localStorage.getItem('postal_code') || 'NA',
      event_time: new Date().toISOString().slice(0, 19),
    };
    this.userService.analytics(data).subscribe((response) => {});
  }

  onClickEmailLogin(popId) {
    ////console.log("verify code");
    const email_id = this.forgot_pasword_email.value;
    localStorage.setItem('forgot_password_email', email_id);
    let token =
      this.verifyTokenEmail.controls.in1.value +
      this.verifyTokenEmail.controls.in2.value +
      this.verifyTokenEmail.controls.in3.value +
      this.verifyTokenEmail.controls.in4.value;
    window.localStorage.setItem('forgot_otp', token);
    if (token.length === 4) {
      //integrate api for login and change UI if login is successfull
      this.loadingService.showLoader();
      this.userService.emailloginwithOtp(token, email_id).subscribe(
        (result) => {
          // this.gdprText=result['data']['gdpr_message']
          // localStorage.setItem('gdprText', this.gdprText);
          // this.isGDPIApproved = result['data']['gdpr_flag']
          this.loadingService.hideLoader();
          this.showPop('reset_password_pop', null);
        },
        (error) => {
          this.loadingService.hideLoader();
          //  this.showErrorMsgSnackbar(error.server_error_messsage === 'Otp Expired'? error.server_error_messsage : 'Entered OTP is incorrect');
          this.showErrorMsgSnackbar(error.server_error_messsage);
          //  //console.log(error)
        },
      );
    } else {
      this.snackbar.open('Please fill all required fields', '', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['red-snackbar'],
      });
    }
  }

  onMouseEnter(event: any) {
    // this.langOptions = false;
    this.userAccountMenu = true;
  }

  onMouseOut(event: any) {
    this.userAccountMenu = false;
  }

  closeAccountMenu() {
    this.userAccountMenu = false;
  }

  mobileToggle(type: string) {
    if (type == 'mobileMenu') {
      this.mobileMenu = true;
      this.profileMenu = false;
      this.mobileMenuOpen = false;
      $('body').addClass('menu-open');
    }
    if (type == 'profileMenu') {
      this.mobileMenu = false;
      this.profileMenu = true;
      this.mobileMenuOpen = false;
    }
    if (type == 'langMenu') {
      this.mobileMenu = false;
      this.profileMenu = false;
      this.mobileMenuOpen = false;
    }
  }

  closeMobileMenu() {
    this.mobileMenu = false;
    this.profileMenu = false;
    this.mobileMenuOpen = true;
    $('body').removeClass('menu-open');
  }

  getMenu() {
    const parentControl =
      window.localStorage.getItem('parentalControl') === 'true'; // Check parental control
    // Conditionally include the parental_control parameter
    const regionWithParams = parentControl
      ? `${this.region}&parental_control=true`
      : this.region;
    this.commonService.getMenuList(regionWithParams).subscribe(
      (resp) => {
        ////console.log(resp);

        this.header_tabs = resp['data']['catalog_list_items'];
        ////console.log( window.location.href);
        let currentTab = this.location.path().split('/')[1];
        // this.activeMenuString = this.header_tabs[0].home_link

        for (var i = 0; i < this.header_tabs.length; i++) {
          ////console.log('header tabs data',this.header_tabs[i].home_link);
          if (this.header_tabs[i].home_link === currentTab) {
            this.activeMenuString = currentTab;
            this.menuRedirect(this.header_tabs[i], i);
          } else if (this.header_tabs[i].home_link === 'o-live') {
            this.activeMenuString = 'o-live';
          } else if (currentTab === '') {
            this.activeMenuString = 'home';
          }

          return;
        }
      },
      (error) => {
        ////console.log(error);

        if (error.server_error_code == 0) {
          this.showPop('no_internet_pop', '');
        } else {
          this.showErrorMsgSnackbar(error.server_error_messsage);
        }
      },
    );
  }

  logoutConfirm(popId) {
    this.clearAllFields();
    let url = window.location.href;
    if (this.location.path() != '/') {
      this.loadingService.showLoader();
    }

    let email =
      JSON.parse(window.localStorage.getItem('user'))?.email_id ||
      JSON.parse(window.localStorage.getItem('user'))?.user_email_id;

    let data = {
      method: email !== null ? 'email' : 'Phone',
      device_id: 'Guest',
      event_name: 'logout',
      age: this.user.age,
      gender: this.user.gender,
      event_id: '',
      creator_id: '',
      platform: this.browser,
      u_id: window.localStorage.getItem('otv_user_analytic_id'),
    };
    this.loadingService.showLoader();
    // this.userService.analytics(data).subscribe(

    //   (resp) => {
    //     //console.log(resp);
    //   },
    //   (error: any) => {
    //     if (error.server_error_code === '1016') {
    //       this.broadcastService.dispatch(
    //         new Message('sessionExpired', null)
    //       );
    //     }
    //   }
    // );
    this.userService.userSignout(this.session).subscribe(
      (res: Response) => {
        this.loadingService.hideLoader();
        // npawPlugin().appAnalytics.endSession();
        this.commonService.removeOtvUserLocalStorage();
        this.session = '';
        // moengage.destroy_session();
        this.closePop('logoutform');
        this.showSuccessMsgSnackbar('Signed out successfully!');
        this.getLocation();
        this.loginStatus = false;
        this.analytics.logEvent('logout', {
          u_id: this.user ? this.user.user_id : 'NA',
        });

       /* webengage.track('Logout', {
          u_id: this.user ? this.user.user_id : 'NA',
        }); */
        this.broadcastService.dispatch(
          new Message('continuewatchonlogout', res),
        );
        this.router.navigate(['/']);
        window.location.reload();
      },
      (error: any) => {
        //this.loadingIndicator = false;
        this.loadingService.hideLoader();
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        } else {
          this.loginStatus = false;
          this.closePop('logout_pop');
          this.showSuccessMsgSnackbar('Signed out successfully!');
          this.getLocation();
          this.router.navigate(['/']);
          if (this.location.path() == '/') {
            window.location.reload();
          }
        }
      },
    );
   /* window.localStorage.clear();
    window.location.reload();*/
  }

  deleteWatchHistory() {
    //this.loadingIndicator = true;
    this.loadingService.showLoader();
    this.analytics.logEvent('app_event_click', {
      e_v: 1,
      typ: 'delete_watch_history',
      vst: 'delete_watch_history',
      app: 'web',
      s_q: '',
      e_t: 'click',
      title: 'delete_watch_history',
      u_st: window.localStorage.getItem('otv_user_analytic_id')
        ? 'registered'
        : 'anonymous',
      u_p_r: 'NA',
      u_p: 'NA',
      u_id: window.localStorage.getItem('otv_user_analytic_id'),
      platform: this.browser,
    });

    this.userService.deleteWatchHistory(this.session, this.region).subscribe(
      (response) => {
        this.loadingService.hideLoader();
        // //console.log(response);
        $('#delete_watch').modal('hide');
        this.showSuccessMsgSnackbar('Your watch history is cleared!');
        this.getContinueWatching();
      },
      (error) => {
        this.loadingService.hideLoader();
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
      },
    );
  }

  // onUserMobileLogin(userLogin: any) { /* user login by email */
  //     if (userLogin.valid) {
  //       //this.loadingIndicator = true;
  //       let url =  window.location.href;
  //       if (this.location.path() != "/") {
  //         this.loadingService.hideLoader();
  //       }

  //       const data = {
  //         "auth_token": "QuyZnN1jzCs3VToJQzYy",
  //         user:{
  //           user_signin_id : this.userMobileLogin.controls.sign_in_userid.value,
  //         password: this.userMobileLogin.controls.sign_in_password.value,
  //         "region": this.region,
  //         "device_type": "web"
  //         }
  //       }

  //       this.loadingService.showLoader();
  //       this.userService.loginWithUserId(data).subscribe(
  //         (response) => {
  //           this.loadingService.hideLoader();

  //           this.showSuccessMsgSnackbar('Logged In Successfully')
  //           $('#signin_pop').modal('hide')
  //           // this.showPop('max_session_limit_popup','')

  //           var userId = response['data']['session'];
  //           this.loginStatus = true;

  //           this.userService.userDetails(response['data']['session'], this.region).subscribe(
  //             (user) => {
  //               //this.loadingIndicator = false;

  //               if (user["data"]["login_type"] == "msisdn") {
  //                 var type = "mobileno";
  //               }
  //               else {
  //                 var type = "email";
  //               }
  //               this.user_det = {
  //                 status: true,
  //                 user_id: userId,
  //                 user_login_type:type ,
  //                 user_name: user["data"]["user_name"],
  //                 user_signin_id: data.user.user_signin_id,
  //                 user_login_id: user["data"]["primary_id"],
  //                 user_analy_id: user['data']['user_id'],
  //                 user_sub_st: user['data']['is_subscribed'],
  //                 user_subscribed: user['data']['is_subscribed']
  //               }

  //               this.userProfileDetails = user['data'];
  //               this.commonService.setOtvUserLocalStorage(this.user_det);
  //               if(window.localStorage){
  //               this.session = window.localStorage.getItem("otv_user_id");
  //               }

  //               let url =  window.location.href;
  //               if (this.location.path() != "/") {
  //                 this.loadingService.hideLoader();
  //               }
  //               this.getContinueWatching();
  //             },
  //             (error: any) => {
  //               //this.loadingIndicator = false;
  //               this.loadingService.hideLoader();
  //               if(error.server_error_code === "1016"){
  //                 this.sessionExpired();
  //               }
  //               this.errorStatus = true;
  //               this.statusMessage = error.server_error_messsage;
  //             }
  //           )
  //         },
  //         (error: any) => {
  //           //this.loadingIndicator = false;
  //           this.loadingService.hideLoader();
  //           this.errorStatus = true;
  //           this.statusMessage = error.server_error_messsage;
  //           this.showErrorMsgSnackbar(error.server_error_messsage)
  //         }
  //       );
  //     }else{
  //       if(!this.userMobileLogin.get('sign_in_userid').hasError('required')){
  //         this.showErrorMsgSnackbar('Password cannot be blank')
  //       }else{
  //         this.snackbar.open('Please fill all required fields','',{
  //           duration:3000,
  //           verticalPosition:'top',
  //           horizontalPosition:'center',
  //           panelClass:['red-snackbar']
  //         })
  //       }
  //     } ;
  // };

  getFavourites() {
    let sId = this.session;
    this.userService.favourites(sId, this.region).subscribe(
      (res) => {
        let favourite_list_items = res.data.items;
        // //console.log("favourites", favourite_list_items);
        if (window.localStorage) {
          window.localStorage.setItem(
            'favouritesList',
            JSON.stringify(favourite_list_items),
          );
        }
        this.getWatchList();
        //this.init();
        this.region == 'IN'
          ? this.closePop('loginform')
          : this.closePop('loginemailform');
      },
      (error) => {
        this.statusMessage = error.server_error_messsage;
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
      },
    );
  }

  getWatchList() {
    let sId = this.session;
    this.userService.watchlist(sId, this.region).subscribe(
      (res) => {
        let watchlist_items = res.data.items;
        // //console.log("watchlist", watchlist_items);
        if (window.localStorage) {
          window.localStorage.setItem(
            'watchList',
            JSON.stringify(watchlist_items),
          );
        }
        let url = window.location.href;
        // if(url.split("#")[1] == "/"){
        //    window.location.reload();
        // }
        // this.broadcastService.dispatch(new Message('playerButtonChangesOnLogin', null));
        this.broadcastService.dispatch(
          new Message('tvVerificationReload', null),
        );
      },
      (error) => {
        this.statusMessage = error.server_error_messsage;
        if (error.server_error_code === '1016') {
          this.sessionExpired();
        }
      },
    );
  }

  showLogin() {
    this.showPop('signin_pop', null);
  }

  showEmailLogin() {
    this.showPop('signin_email_pop', null);
  }

  openProfileOrLogin() {
    if (!this.session || !window.localStorage.getItem('otv_user_id')) {
      this.loginBasedonRegion();
      return;
    }
    this.showPop('my-profile_pop', '');
  }

  userDetails(fromProfile: boolean = false) {
    let email;
    let sessionId = this.session;
    // let sessionId = 'd705453f9e2284be844c81229c70053c';
    if (!sessionId) {
      if (fromProfile) {
        this.loginStatus = false;
        this.loginBasedonRegion();
      }
      return;
    }
    if (this.browser != 'android') {
      this.userService.userDetails(sessionId, this.region).subscribe(
        (user) => {
          this.user = user.data;
          this.loginType = user.data.login_type;
          //console.log(this.user,"---------------------------------");
          this.userProfile
            .get('user_profile_name')
            .setValue(this.user.firstname);
          this.userProfile.get('user_profile_age').setValue(Number(this.user.age));
          this.userProfile
            .get('user_profile_mobileNo')
            .setValue(this.user.mobile_number);
          this.userProfile
            .get('user_profile_email')
            .setValue(this.user.email_id);
            this.userProfile
  .get('user_profile_name')
  .setValue(this.user.firstname);
this.userProfile.get('user_profile_age').setValue(Number(this.user.age));
this.userProfile
  .get('user_profile_mobileNo')
  .setValue(this.user.mobile_number);
this.userProfile
  .get('user_profile_email')
  .setValue(this.user.email_id);

// ADD THIS NEW BLOCK ↓↓↓
setTimeout(() => {
  document.querySelectorAll('.profile_pop_input_wid').forEach((el: any) => {
    el.scrollLeft = 0;
    try {
      if (el.setSelectionRange) {
        el.setSelectionRange(0, 0);
      }
    } catch {
      // some input types (email, number) don't support setSelectionRange — safe to ignore
    }
  });
}, 0);

          window.localStorage.setItem('user', JSON.stringify(this.user));
          window.localStorage.setItem('sessionId', sessionId);

          webengage.user.setAttribute('we_email', this.user.email_id);
          webengage.user.setAttribute('we_first_name', this.user.firstname);
          webengage.user.setAttribute('we_phone', this.user.mobile_number);

          // //console.log( this.userProfile.value)
          this.activePlans = user.data.is_subscribed;
          this.accessPack = user.data.active_plans;
          if (this.activePlans) {
            //console.log("inside the active plans")
            if (
              this.accessPack.includes('all_access_pack') ||
              this.accessPack.includes('livetv_and_originals')
            ) {
              this.showSubscribeButton = true;
            }
          }
        },
        (error) => {
          this.statusMessage = error.server_error_messsage;
          if (error.server_error_code === '1016' || error.server_error_messsage === 'Invalid User Id') {
            this.sessionExpired();
          }
        },
      );
    }
  }

  ValidateEmail(mail) {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail,
      )
    ) {
      return mail;
    } else {
      return '';
    }
  }

  onPlansMenuClick(): void {
    if (window.localStorage) {
      window.localStorage.setItem('plans_source_screen', 'home');
    }
  }

  menuRedirect(item, i, fromClick = false) {
    if (fromClick) {
      this.trackMenuCategoryViewed(item);
    }
    // //console.log(item['home_link'])
    //let menuItems = document.getElementsByClassName('menu-item');
    let url;
    if (this.mobileMenu) {
      this.closeMobileMenu();
    }
    if (item['display_title'] && item['display_title'].toLowerCase() == 'all') {
      url = '/';
      this.activeMenuString = item.home_link;
      this.router.navigate(['/']);
    } else if (item === 'plans') {
      this.activeMenuString = item;
      console.log('plans clicked --------------------------');
      if (window.localStorage) {
        window.localStorage.setItem('isDetailspage', 'false'); //after subscription redirection to home page
        window.localStorage.setItem('plans_source_screen', 'home');
      }

      fbq('track', 'SubscribedButtonClick', {
        button_text: 'Subscribe',
        page_url: window.location.href,
        manual_trigger: true,
      });

      this.router.navigate(['/plans']);
    } else if (item['home_link'] === 'o-live') {
      this.activeMenuString = 'o-live';
      this.router.navigate(['/live-tv']);
    } else if (item['home_link'] === 'Rumble') {
      this.activeMenuString = 'Rumble';
      window.location.href = 'https://dangal.play.rumbleapp.gg/';
      //   const rumbleUrl = 'https://dangal.play.rumbleapp.gg/';
      // window.open(rumbleUrl, '_blank');
    } else if (item == 'watchlater') {
      url = '/users/watchlist';
      this.router.navigate([url]);
    } else if (item == 'tv') {
      url = '/tv';
      this.router.navigate([url]);
    } else if (
      item['home_link'] === 'shorts' ||
      item['home_link'] === 'shorts-list' ||
      (item['display_title'] &&
        item['display_title'].toLowerCase() === 'shorts')
    ) {
      this.activeMenuString = item.home_link || 'shorts-list';
      this.router.navigate(['/shorts-list']);
    } else {
      url =
        item['display_title'].toLowerCase() != 'home' ? item['home_link'] : '/';
      let vst, title;
      this.activeMenuString = item.home_link;
      if (item['display_title'].toLowerCase() == 'event') {
        vst = item['display_title'].toLowerCase();
        title = 'liv9ja';
      } else {
        vst = item['display_title'].toLowerCase();
        title = vst;
      }

      this.router.navigateByUrl('/').then(() => this.router.navigate([url]));
    }

    // //console.log(this.activeMenuString)
  }

  private trackMenuCategoryViewed(item: any): void {
    try {
      const isPlans = item === 'plans';
      const isWatchlater = item === 'watchlater';
      const isTv = item === 'tv';
      const category_id = isPlans
        ? 'plans'
        : isWatchlater
          ? 'watchlist'
          : isTv
            ? 'tv'
            : ((item && item.home_link) || '').toString() || '-';
      const category_name = isPlans
        ? 'Plans'
        : isWatchlater
          ? 'Watchlist'
          : isTv
            ? 'TV'
            : ((item && item.display_title) || '').toString() || '-';

      const payload = {
        category_id,
        category_name,
        source_screen: 'home',
      };
      if (typeof webengage !== 'undefined' && webengage?.track) {
        webengage.track('Category Viewed', payload);
      }
    } catch (e) {}
  }

  menuOtherRedirect(url) {
    let vst;
    if (url == 'live-tv') {
      vst = url;
    } else if (url == 'events') {
      vst = 'liv9ja';
    } else if ((url = 'loveisland')) {
      vst = url;
    }

    this.router.navigateByUrl('/').then(() => this.router.navigate([url]));
  }

  openInNewWindow(route) {
    this.router.navigate([route]);
    // window.open(globals.site+route+'?type="mobile', '_blank');
  }

  onCountrycodeSelection(e) {
    e.source._elementRef.nativeElement.querySelector(
      '.mat-select-min-line',
    ).innerHTML = e.value.dial_code;
    this.minPhnLimit = e.value.min_limit;
    this.maxPhnLimit = e.value.max_limit;
  }

  closeSwitchNetwork() {
    this.closeSwitchNetworkPopup = false;
  }

  agreeGDPI() {
    const signinemail = window.localStorage.getItem('signed_emailid');
    const data = {
      email: signinemail,
      status: false,
    };
    this.loadingService.showLoader();
    this.userService.gdpiStatus(data).subscribe(
      (result) => {
        this.loadingService.hideLoader();
        this.isGdprPopupVisible = false;
        localStorage.setItem('gdpr_flag', 'false');
      },
      (error) => {
        this.loadingService.hideLoader();
      },
    );
  }

  loginCheckSursangram() {
    this.showSursangramPop = false;
    // this.npawContentId = undefined;
    // this.npawSource = 'organic';
    if (!window.localStorage.getItem('otv_user_id')) {
      this.loginBasedonRegion();
    } else if (this.browser != 'android' && this.browser != 'ios') {
      // this.closePop('sursangram_pop');
      this.router.navigate(['/sursangram']);
      this.analytics.logEvent('sur_sangram_click', {
        source: window.localStorage.getItem('globalTabName'),
        video_name: window.localStorage.getItem('globalSsName'),

        tray_name: window.localStorage.getItem('globalTrayName'),
        position_within_tray: 'NA',
        u_id: window.localStorage.getItem('otv_user_analytic_id'),
        platform: this.browser,
      });
    }
  }

  onMouseEnterBeforeLogin(event: any) {
    this.userAccountMenuBeforeLogin = true;
  }
  closeAccountMenuBeforeLogin() {
    this.userAccountMenuBeforeLogin = false;
  }
  onMouseOutbeforelogin(event: any) {
    this.userAccountMenuBeforeLogin = false;
  }

  onTermsChange(event: any) {
    this.termsAccepted = event.target.checked;
  }

  onRegister(): void {
    this.hasAttemptedSubmit = true;
    if (!this.termsAccepted) {
      return;
    }
    if (this.registerForm.valid) {
      const countryCode = this.registerForm.value.region;
      this.mobileNumber = countryCode + this.registerForm.value.email_id; // Store mobile number in the class property
      // this.mobileNumber = `${countryCode === '+91' ? '+91' : countryCode}` + mobileNumber;

      this.forgotPassMobileNumber = this.mobileNumber;
      if (this.mobileNumber) {
        const registerData = {
          ...this.registerForm.value,
          email_id: this.mobileNumber,
          type: 'msisdn',
        };
        if (registerData.region === '+91') {
          registerData.region = 'IN';
        }
        this.userService.userRegister(registerData).subscribe(
          (response) => {
            localStorage.setItem('phone_login_type', 'Sign_up');
            sessionStorage.setItem(PB_SIGNUP_FLOW_START_TS, String(Date.now()));
            sessionStorage.setItem(PB_SIGNUP_OTP_FAILURE_COUNT, '0');
            // this.snackbar.open('OTP sent to your registered mobile number: ' + response.data.otp, 'Close', {
            this.snackbar.open(
              'OTP sent to your registered mobile number: ',
              'Close',
              {
                duration: 10000,
                verticalPosition: 'top',
                panelClass: ['success-snackbar'],
              },
            );
            this.keepOtpCountdown = true;
            this.showPop('signin_otp_pop', '');
            setTimeout(() => {
              this.startTimer('');
            }, 400);
          },
          (error) => {
            this.showErrorMsgSnackbar(
              error.server_error_messsage ||
                'Something went wrong. Please try again.',
            );
          },
        );
      } else {
        this.snackbar.open('Please enter a valid mobile number.', 'Close', {
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar'],
        });
      }
    } else {
      const emailCtrl = this.registerForm.get('user_email_id');
      const mobileCtrl = this.registerForm.get('email_id');
      if (emailCtrl?.errors?.['pattern']) {
        this.showErrorMsgSnackbar('Please enter a valid Email Address to continue.');
      } else if (mobileCtrl?.errors?.['required'] || mobileCtrl?.errors?.['pattern']) {
        this.showErrorMsgSnackbar('Please enter a valid Mobile Number to continue.');
      } else {
        this.showErrorMsgSnackbar('Please fill all required fields correctly.');
      }
    }
  }
  closeregisterPopup(popupId: string): void {
    if (popupId === 'register-popup') {
      const countryCode = this.registerForm.value.region;
      this.registerForm.reset();
      this.registerForm.patchValue({ region: countryCode });
    }
    localStorage.setItem('phone_login_type', 'Sign_up');
    // Close the popup logic here
    const popup = document.getElementById(popupId);
    if (popup) {
      popup.style.display = 'none';
    }
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const numericValue = input.value.replace(/\D/g, '');
    if (numericValue.length > 10) {
      input.value = numericValue.slice(0, 10);
    } else {
      input.value = numericValue;
    }
    this.registerForm.controls['email_id'].setValue(input.value);
  }

  signInWithFacebook() {
    this.userService
      .facebookSignIn(this.region)
      .then((response: any) => {
        //console.log('User data sent to API:', response);

        if (response && response.data) {
          this.showSuccessMsgSnackbar('Signed In Successfully!');
          this.getLocation();
          this.closePop('signin_google_pop');

          // Store the login details
          const loginDetails = response.data;

          // this.gdprFlag = response.gdpr_flag;
          this.gdprFlag = response.gdpr_flag ?? false;
          localStorage.setItem('gdpr_flag', this.gdprFlag.toString());
          this.signed_emailid = response.data.email_id;
          window.localStorage.setItem('signed_emailid', this.signed_emailid);
          this.loginStatus = true;
          this.user_det = {
            status: true,
            user_id: loginDetails.session_id,
            user_name: loginDetails.firstname,
            user_signin_id: loginDetails.user_id,
            user_login_type: loginDetails.login_type,
            user_analy_id: loginDetails.user_id,
            user_subscribed: loginDetails.new_user,
          };

          this.commonService.setOtvUserLocalStorage(this.user_det);
          this.userDetails();

          if (loginDetails?.new_user) {
            const payload = {
              registration_method: 'facebook',
              mobile_number_provided: !!loginDetails?.mobile_number,
              ...this.userRegisteredContext(false, loginDetails),
            };
            console.log('WebEngage User Registered', payload);
            webengage.track('User Registered', payload);
          }

          this.saranyu_login(
            loginDetails.user_id,
            'facebook',
            response.data.email_id,
            'login_success',
          );

          // Analytics logging (optional)
          // this.analytics.logEvent('login_success', {
          //   method: 'Facebook',
          //   u_id: loginDetails.user_id,
          //   platform: this.browser,
          // });

          this.userPlans('signIn');
          this.getContinueWatching();
          this.reloadAfterLogin();
        }
      })
      .catch((error: any) => {
        this.showErrorMsgSnackbar(
  'Facebook Sign-In Failed: ' + (error?.message || error?.server_error_messsage || 'An error occurred'),
);
        console.error('Error during Facebook Sign-In:', error);
        console.log('Tracking Signup Failure');
        webengage.track('Signup Failure', {
          failure_step: 'facebook_signin',
      failure_reason: error?.message || error?.server_error_messsage || 'An error occurred',
      registration_method_attempted: 'facebook',
        });
      });
  }

  signInWithGoogle() {
    this.userService
      .googleSignIn(this.region)
      .then((response: any) => {
        //console.log('User data sent to API:', response);

        if (response && response.data) {
          this.showSuccessMsgSnackbar('Signed In Successfully!');
          this.getLocation();
          this.closePop('signin_google_pop');

          // Store the login details
          const loginDetails = response.data;
          // this.gdprFlag = response.gdpr_flag;
          this.gdprFlag = response.gdpr_flag ?? false;
          localStorage.setItem('gdpr_flag', this.gdprFlag.toString());
          this.signed_emailid = response.data.email_id;
          window.localStorage.setItem('signed_emailid', this.signed_emailid);
          window.localStorage.setItem('user', JSON.stringify(this.user));
          this.loginStatus = true;
          this.user_det = {
            status: true,
            user_id: loginDetails.session_id,
            user_name: loginDetails.firstname,
            user_signin_id: loginDetails.user_id,
            user_login_type: loginDetails.login_type,
            user_analy_id: loginDetails.user_id,
            user_subscribed: loginDetails.new_user,
          };

          this.commonService.setOtvUserLocalStorage(this.user_det);
          this.userDetails();

          // Analytics logging (optional)
          // this.analytics.logEvent('login_success', {
          //   method: 'google',
          //   u_id: loginDetails.user_id,
          //   platform: this.browser,
          // });

          // webengage.track('Login Success', {
          //   method: 'google',
          //   u_id: loginDetails.user_id,
        //  platform: this.browser,
         // });
         

          if (loginDetails?.new_user) {
            const payload = {
              registration_method: 'google',
              mobile_number_provided: !!loginDetails?.mobile_number,
              ...this.userRegisteredContext(false, loginDetails),
            };
            console.log('WebEngage User Registered', payload);
            webengage.track('User Registered', payload);
          }

          this.saranyu_login(
            loginDetails.user_id,
            'google',
            this.signed_emailid,
            'login_success',
          );

          this.userPlans('signIn');
          this.getContinueWatching();
          this.reloadAfterLogin();
        }
      })
      .catch((error: any) => {
        this.showErrorMsgSnackbar(
          'Google Sign-In Failed: ' + error.server_error_messsage ||
            'An error occurred',
        );
        console.error('Error during Google Sign-In:', error);
        console.log('Tracking Signup Failure');
        webengage.track('Signup Failure', {
          failure_step: 'Google signin',
          failure_reason: error.server_error_messsage,
          registration_method_attempted: 'Google',
        });
      });
  }

  /**
   * User Registered payload fields aligned with Android.
   * Unused Android keys are '-'. Identity fields come from the login/register API.
   * When includeOtpTiming is true, clears OTP flow session markers (timing is unused on Android).
   */
  private userRegisteredContext(
    includeOtpTiming: boolean,
    user?: {
      email_id?: string;
      firstname?: string;
      user_id?: string | number;
    },
    formFallback?: { email?: string; name?: string },
  ): Record<string, string | boolean> {
    const email = (
      user?.email_id ||
      formFallback?.email ||
      ''
    )
      .toString()
      .trim();
    const name = (
      user?.firstname ||
      formFallback?.name ||
      ''
    )
      .toString()
      .trim();
    const userId =
      user?.user_id != null && String(user.user_id).trim() !== ''
        ? String(user.user_id)
        : '-';

    if (includeOtpTiming) {
      sessionStorage.removeItem(PB_SIGNUP_FLOW_START_TS);
      sessionStorage.removeItem(PB_SIGNUP_OTP_FAILURE_COUNT);
    }

    const ctx: Record<string, string | boolean> = {
      registration_source: '-',
      country: '-',
      EmailID: '-',
      app_version: '-',
      device_model: '-',
      city: '-',
      Email_ID: email || '-',
      os_version: '-',
      email_provided: !!email,
      ua: '-',
      time_to_register_sec: '-',
      platform: '-',
      Name: name || '-',
      user_id: userId,
      Phone: '-',
      state: '-',
      network_type: '-',
      signup_attempt_number: '-',
      preferred_language_at_signup: '-',
    };

    const ref = localStorage.getItem('referral_code')?.trim();
    if (ref) ctx.referral_code_used = ref;

    return ctx;
  }

  confirmDeleteUser() {
    // let cleanedMobileNumber = this.user.mobile_number.replace('+', '');
    let sessionUserId = this.session;
    this.userService.deleteUserAccount(sessionUserId).subscribe(
      (response) => {
        // //console.log('User account deleted successfully', response);
        window.localStorage.clear();
        window.location.reload();
      },
      (error) => {
        // console.error('Error deleting user account', error);
        // alert('There was an error deleting the account. Please try again.');
      },
    );
  }

  OnClickUpcomingMenu() {
    this.upcomingMenuOpen = true;
  }

  closeUpcomingMenu() {
    this.upcomingMenuOpen = false;
  }

  //Please uncomment the lines after the upcoming api is ready
  getUpcomingData() {
    const parentControl =
      window.localStorage.getItem('parentalControl') === 'true'; // Check parental control

    // Call the service method with the parentControl flag
    this.commonService.getUpcomingData(parentControl).subscribe((resp) => {
      this.UpcomingData = resp['data']['catalog_list_items'];
      // //console.log('res comingsoon:', resp);
    });
  }

  //Please uncomment the lines after the upcoming api is ready
  UpcomingItemClicked(i) {
    this.upcomingMenuOpen = false;
    // this.router.navigate([`/${i.catalog_name}/${i.friendly_id}`]).then(() => {
    //   this.commonService.reloadCurrentRoute();
    // });
    window.localStorage.setItem('globalTabName', 'coming soon');
    window.localStorage.setItem('globalTrayName', '');
    window.localStorage.setItem('globalTrayId', '');
  }
  keytabTV(e) {
    this.disableActivate =
      this.verifyToken.controls.in1?.value?.length > 0 &&
      this.verifyToken.controls.in2?.value?.length > 0 &&
      this.verifyToken.controls.in3?.value?.length > 0 &&
      this.verifyToken.controls.in4?.value?.length > 0 &&
      this.verifyToken.controls.in5?.value?.length > 0 &&
      this.verifyToken.controls.in6?.value?.length > 0
        ? false
        : true;
    if (e.key == 'Backspace') {
      if (e.target.previousElementSibling) {
        e.target.previousElementSibling.focus();
      }
    } else if (e.key.length == 1) {
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
        //console.log(e.target.nextElementSibling.getAttribute('formcontrolname'));
      }
    }
  }
  clear() {
    this.verifyTokenForm.resetForm();
    this.errorFlag = false;
    this.disableActivate = true;
  }
  numbCharOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode > 47 && charCode < 58) ||
      (charCode > 64 && charCode < 91) ||
      (charCode > 96 && charCode < 123)
    ) {
      return true;
    }
    return false;
  }

  onClickEditProfile() {
    this.onClickProfilePop();
    this.showUpdateProfile = true;
    setTimeout(() => {
      document.querySelectorAll('.profile_pop_input_wid').forEach((el: any) => {
        el.scrollLeft = 0;
        try {
          if (el.setSelectionRange) {
            el.setSelectionRange(0, 0);
          }
        } catch {
          // some input types (email, number) don't support setSelectionRange
        }
      });
    }, 50);
  }
}